// en, de, fr, br
import validationMessages from "vee-validate/dist/locale/es";

export default {
    //es: {
    validations: {
        messages: {
            ...validationMessages.messages,
            "email-or-cpf":
                "El campo {_field_} no es un CORREO ELECTRÓNICO o CPF válido",
            cpf: "El campo {_field_} tiene un formato inválido",
            cnpj: "El campo {_field_} tiene un formato inválido",
            pis: "El campo {_field_} tiene un formato inválido",
            "zip-code": "El campo {_field_} tiene un formato inválido",
            "full-name": "El campo {_field_} es inválido",
            date: "El campo {_field_} es una fecha inválida",
            "before-date": "La fecha proporcionada es mayor que la fecha final",
            "after-date":
                "La fecha proporcionada es menor que la fecha inicial",
            "minority-date": "La edad mínima para registrarse es de 14 años.",
            required_unless: "El campo {_field_} es obligatorio",
            must_exists_if: "Es necesario seleccionar al menos una opción",
            cns: "El campo {_field_} tiene un formato inválido",
            "password-username-checker": "La contraseña proporcionada no puede ser utilizada.",
            "password-weakness-checker": "La contraseña proporcionada es muy debil.",
            "cellphone": "El campo {_field_} tiene un formato inválido",
        },
    },
    //Find a better place to allocate this ↓↓↓
    image: {
        change_image: "Cambiar imagen",
        send_image: "Enviar imagen"
    },
    files: {
        remove: {
            done: "Archivo eliminado con éxito",
            fail: "No se pudo eliminar su archivo. Por favor, inténtelo de nuevo",
        },
        the_requested_file_could_not_be_found: "No se pudo encontrar el archivo solicitado",
    },
    changeable: {
        "indicator-text":
            "Cambios guardados | {count} cambio pendiente | {count} cambios pendientes",
    },
    errors: {
        403: "Acceso no permitido",
        404: "Página no encontrada",
        "create-password": "¡Cree una contraseña!",
        account_recover: {
            "not-found": "Datos inválidos, inténtelo de nuevo.",
        },
        link_account: {
            "already-existent":
                "Ya existe un registro con este documento. Si no recuerda el acceso, recupere su cuenta en la pantalla de inicio de sesión.",
        },
        communication: {
            "not-sent":
                "No se pudo registrar su contacto. Por favor, inténtelo de nuevo",
        },
        title: {
            danger: "Error",
            warning: "Advertencia",
            info: "Información",
        },
        "default-title": "Error",
        account: {
            error: "Error al enviar el correo electrónico de restablecimiento, inténtelo de nuevo.",
            "social-media-account":
                "Su cuenta fue creada a partir de una red social. Para recuperar su cuenta, póngase en contacto con la empresa responsable.",
            "not-found":
                "Cuenta no encontrada, verifique si el CPF fue ingresado correctamente.",
            "password-reset-throttled":
                "Se envió un correo electrónico de restablecimiento hace unos momentos, espere 10 minutos antes de intentarlo de nuevo.",
        },
        registration: {
            message:
                "No se pudo completar su registro. Por favor, inténtelo de nuevo.",
            message_alt: "No se pudo registrar. Por favor, inténtelo de nuevo.",
            "account-existent":
                "¡Ya tiene una cuenta! Inicie sesión para continuar.",
            cpf_already_registered_in_our_database: "¡CPF ya registrado en nuestra base de datos!",
        },
        curriculum: {
            "not-found": "Currículum no encontrado",
            invalid_zip_format:  "El campo de código postal tiene un formato inválido",
            invalid_bank_name_list:
                "Seleccione un banco de la lista permitida para este proceso de selección.",
        },
        vacancy: {
            "not-found": "Vacante no encontrada",
            "not_found_description": "La vacante que buscas no fue encontrada.<br/>Haz clic en el botón de abajo para ver otras oportunidades disponibles.",
            "expired": "Vacante no disponible",
            "expired_description": "Esta vacante ya no acepta postulaciones.<br/>Haz clic en el botón de abajo para ver otras oportunidades."
        },
        enroll: {
            "not-found": "Vacante no encontrada",
            "already-applied": "¡Ya se ha postulado a esta vacante!",
            "already-applied-title": "¡Ya se ha postulado!",
            forbidden: "No tiene permiso para postularse a esta vacante",
            "unfilled-fields": "Hay algunos campos necesarios para completar la solicitud. Por favor, complete los campos a continuación para continuar:",
            "does-not-attend": "Su currículum no cumple con los requisitos mínimos a continuación:",
            "maintain-updated": "Mantenga siempre su currículum actualizado para nuevas oportunidades.",
            pcd: "PCD",
            education: "Formación Académica",
            languages: "Idiomas",
            computing: "Computación",
            "exclusive-selective-process": "Este proceso de selección requiere exclusividad y el candidato está participando en otro proceso",
            "application-closed": "¡Gracias por tu interés! Lamentablemente, esta oportunidad ya no está aceptando postulaciones."
        },
        file: {
            file_upload_failed: "¡La carga del archivo no se realizó con éxito!"
        }
    },
    responses: {
        communication: {
            success:
                "Hemos recibido su solicitud y nos pondremos en contacto lo antes posible para resolverla",
        },
        feedback: {
            success: "¡Gracias por su ayuda!",
        },
    },
    ocr: {
        error_title: "¡Atención!",
        error_description:
            "No pudimos identificar alguna información del documento:",
        error_validate: "Por favor, verifique:",
        error_validate_item_1: "La imagen del documento adjunto",
        error_validate_item_2: "El llenado de los campos anteriores",
        await_title: "Espere",
        await_description:
            "Por favor espere, estamos validando la información del documento.",
    },
    parsing: {
        send_another_file: "Enviar otro archivo",
        check_the_info:
            "Verifique que los campos estén correctamente llenos y complete lo que sea necesario",
        ready: "¡Listo!",
        read_file: "Leyendo su currículum...",
        start_fill: "Iniciar llenado",
        search_file: "Buscar archivo",
        send_file:
            "Si lo prefiere, envíe su currículum (PDF o Word) para crear su perfil como por arte de magia",
    },
    common: {
        understood: "Entendido",
        wait: "¡Espere!",
        saving_info: "Guardando información...",
        saving_changes: "Guardando cambios...",
        dependent: "Dependiente",
        attention: "Atención",
        success: "Éxito",
        saved_successfully: "Guardado exitosamente",
        error: "Error",
        loading: "Cargando",
        send: "Enviar",
        my_painel: "Mi Panel",
        complementary_data: "Datos Complementarios",
        admission_data: "Datos de Admisión",
        apply: "Aplicar",
        yes: "Sí",
        create_new_section: "Crear nueva sección",
        no: "No",
        male: "Masculino",
        female: "Femenino",
        required: "Campo obligatorio",
        back_to_home: "Volver al inicio",
        edit: "Editar",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        upload_photo: "Cargar Foto",
        advance: "Avanzar",
        "no-results-found": "No se encontraron resultados",
        "search-new-term": ", ingrese una nueva búsqueda.",
        see: "Ver",
        search: "Buscar",
        or: "o",
        and: "y",
        description: "Descripción",
        progress: "Progreso",
        link_with_sj: "Vincular con SelectyJobs",
        link_with_facebook: "Vincular con Facebook",
        link_with_linkedin: "Vincular con LinkedIn",
        link_with_google: "Vincular con Google",
        join: "Entrar",
        join_with_sj: "Entrar con SelectyJobs",
        join_with_facebook: "Entrar con Facebook",
        join_with_linkedin: "Entrar con LinkedIn",
        join_with_google: "Entrar con Google",
        join_with_ecidadao: "Entrar con E-Cidadão",
        join_with_ad: "Entrar con Active Directory",
        please_type_captcha_correctly:
            "Por favor, complete el captcha correctamente.",
        to_continue_auth:
            "Para continuar, seleccione una de las opciones a continuación",
        register: "Registrarse",
        create_account: "Crear Cuenta",
        create_profile: "Crear perfil",
        profile: "Perfil",
        lets_begin: "¡Vamos a empezar!",
        lets_begin_subtitle: "Rellene la siguiente información básica",
        jobs: "Vacantes",
        show: "Mostrar",
        hide: "Ocultar",
        hello: "Hola",
        complete_curriculum: "Completar mi currículum",
        follow_process: "Seguir proceso de selección",
        curriculum: "Currículum",
        admissional: "Admisión",
        logout: "Cerrar sesión",
        exit_warning: "Hay campos obligatorios sin completar, ¿realmente deseas salir?",
        begin: "Inicio",
        vacancy: "Vacantes",
        messages: "Mensajes",
        account: "Cuenta",
        email: "Correo electrónico",
        password: "Contraseña",
        change: "Cambiar",
        close: "Cerrar",
        in: "en",
        click: "Haga clic aquí",
        to_add: "para agregar",
        captcha_error: "Por favor, complete el captcha correctamente.",
        course_not_found: "No se pudo encontrar el curso",
        institution_not_found: "No se pudo encontrar la institución",
        document_not_found: "No se pudo encontrar el documento",
        training_not_found: "No se pudo encontrar la capacitación",
        occupation_not_found: "No se pudo encontrar el cargo",
        computing_knowledge_not_found: "No se pudo encontrar el conhecimento",
        please_insert_document: "Por favor, ingrese su CPF.",
        why_we_need_that: "¿Por qué solicitamos esta información?",
        creation_garantee:
            "Queremos garantizar que tendrá un registro único con una identificación segura. Por eso, el CPF será su clave principal de acceso.",
        validate_informations: "Validar información",
        present: "hasta el momento",
        create_professional_profile:
            "¡Registre su perfil profesional ahora mismo!",
        start_end: "Inicio/Fin",
        period: "Período",
        visit: "Visitar",
        for_companies: "Para empresas",
        notification_updated_successfully: "Notificación actualizada con éxito",
        failed_to_update_data: "Error al actualizar los datos.",
        user_successfully_linked: "¡Usuario vinculado con éxito!",
        successfully_completed: "Finalizado con éxito",
        updated_successfully: "Actualizado con éxito",
        status_updated: "Estado actualizado",
        status_not_updated: "Estado no actualizado",
        email_updated_successfully: "Email actualizado con éxito",
        password_changed_successfully: "Contraseña cambiada con éxito",
        avatar_successfully_updated: "Avatar alterado con éxito",
        your_request_was_successfully_completed: "Su solicitud se realizó con éxito",
        invalid_data: "¡Datos inválidos!",
        incorrect_data: "Datos incorrectos",
        invalid_captcha: "¡Captcha inválido!",
        successfully_saved: "Guardado con éxito",
        data_save_error: "Error al guardar los datos",
        physical: "Físico",
        digital: "Digital",
        field_mismatch:  "El campo no coincide con el archivo enviado",
        application: "Candidatura",
        results: "Resultado",
        answer: "Responder",
        perform_assessment: "Realizar evaluación",
        download_file: "Descargar archivo",
        accepted: "Aceptado",
    },
    redirecting: {
        redirecting: "Redirigiendo",
        please_wait: "Por favor espere...",
        access_forbiden: "Acceso no autorizado",
        enroll_portal: "Será redirigido al portal",
    },
    reset_password: {
        passwords: {
            sent: "Correo enviado con éxito.",
            user: "Correo enviado con éxito.",
            token: "Token inválido. Por favor, repita el proceso.",
            reset: "Tu contraseña ha sido cambiada exitosamente.",
        },
    },
    password_level: {
        very_week: "Muy débil",
        week: "Débil",
        regular: "Regular",
        strong: "Muy fuerte",
    },
    forms: {
        fields: {
            upload: "Adjuntar Archivo",
            remove_file: "Eliminar archivo",
            allowed_extensions: "Extensiones permitidas",
            default_error:
                "No fue posible enviar el archivo. Por favor, inténtelo de nuevo",
        },
    },
    company: {
        config: {
            logo_position: {
                label: "",
                placeholder: "",
                description: "",
            },
        },
    },
    customize: {
        main_title: "Personalizar",
        subtitle:
            "Elige el color del tema, añade áreas de contenido, fotos y más.",
        color_theme: "Color del tema",
        color_theme_description: "Afecta botones y elementos interactivos.",
        logo_position: "Posición del logo",
        logo_position_description:
            "Selecciona la mejor posición para tu logo en el portal.",
        sections: "Áreas de contenido",
        sections_description:
            "Arrastra la sección para cambiar la posición de visualización.",

        type: {
            placeholder: "Seleccionar",
        },
        base_theme: {
            label: "Tema Principal",
            placeholder: "Selecciona el tema principal",
            description: "",
        },
        "primary-color": {
            label: "Color primario",
            placeholder: "Selecciona el color primario",
            description: "",
        },
        title: {
            label: "Título",
            placeholder: "Ingresa el Título",
            description: "",
        },
        banner: {
            add_banner: "Agregar Banner",
            remove_banner: "Eliminar Banner",
            more_details: "Más detalles",
            redirect_url: {
                label: "Enlace de redirección",
                placeholder: "",
                description: "",
            },
            banner_specifications: {
                recommended_dimensions: "Dimensiones recomendadas:",
                maximum_file_size: "Tamaño máximo del archivo:",
                supported_files: "Archivos soportados:",
                dimensions: "1920 x 560px",
                size: "10mb",
                formats: "JPG o PNG"
            },            
        },
    },
    passwords: {
        cpf: {
            label: "CPF",
            placeholder: "Ingrese su CPF",
            description: "",
        },
        cellphone: {
            label: "Celular",
            placeholder: "Ingrese el número de celular registrado",
            description: "",
        },
        birth_date: {
            label: "Fecha de Nacimiento",
            placeholder: "Ingrese su fecha de nacimiento",
            description: "",
        },
        primary_email: {
            label: "Correo electrónico",
            placeholder: "Ingrese su correo electrónico registrado",
            description: "",
        },
        mother_name: {
            label: "Nombre de la madre",
            placeholder: "Ingrese el nombre de la madre",
            description: "",
        },
    },
    user: {
        login: {
            email: {
                label: "Correo electrónico",
                placeholder: "",
                description: "",
            },
            is_foreigner: {
                label: "Soy extranjero",
                placeholder: "",
                description: "",
            },
            login: {
                label: "CPF",
                placeholder: "",
                description: "",
            },
            password: {
                label: "Contraseña",
                placeholder: "",
                description: "",
            },
            submit: "Ingressar",
            linked: "Ingresar con LinkedIn",
            sj: "Ingresar con SelectyJobs",
            joinMessage: "Inicia sesión para continuar",
            joinSjMessage:
                "Inicia sesión en tu cuenta de SelectyJobs para continuar",
            needAccount: "¿No está registrado?",
            create_account: "Crear una cuenta",
            forgotPassword: "¿Ha olvidado su contraseña?",
            invalidEmailOrPassword:
                "Correo electrónico y/o contraseña (s) inválida (s).",
            forgotUsername: "¿Olvidó sus datos de acceso?",
        },
        forgot: {
            login: {
                label: "CPF",
                placeholder: "Ingrese su CPF",
                description: "",
            },
            nextStep: "Siguiente",
            title: "¿Olvidaste tu contraseña?",
            info: "No te preocupes. Te enviaremos un correo electrónico con instrucciones para crear una nueva contraseña.",
            submit: "Crear nueva contraseña",
            return_to: "Volver al inicio de sesión",
            email_sent: "¡Correo electrónico enviado!",
            email_instructions:
                "Enviamos un correo electrónico a {email} con instrucciones para crear una nueva contraseña.",
            email_spam_instructions:
                "Si el correo electrónico tarda en llegar, revisa tu bandeja de spam.",
            minimal_recovery_instructions:
                "Si existe un currículum registrado con los datos informados, se enviará un correo electrónico para que pueda cambiar la contraseña.",
            no_longer_email_access:
                "Ya no tengo acceso a este correo electrónico",
            recover_account: "Recuperar cuenta",
            recover_account_failure: "Error al recuperar la cuenta.",
            contact_to:
                "Error al validar los datos de la cuenta. Para recuperar tu cuenta, comunícate con {company_name}.",
            social_media_account:
                "Tu cuenta fue creada a través de una red social, inicia sesión por esa red social o recupera la cuenta a continuación:",
            atention: "¡Atención!",
        },
        forgotAccount: {
            title: "¿Olvidaste tus datos de acceso?",
            info: "¡No te preocupes! Validaremos algunos datos para recuperar tu cuenta.",
            next: "Siguiente",
            validate_data: "Validar datos",
        },
        confirmAccountData: {
            title: "¡Encontramos tu cuenta!",
            info: "Por tu seguridad, confirmaremos algunos datos antes de recuperar tu cuenta.",
            cellphone:
                "Confirma a continuación el número de celular registrado en tu cuenta:",
            birth_date: "Confirma a continuación tu fecha de nacimiento:",
            email: "Confirma a continuación el correo electrónico registrado en tu cuenta:",
            email_secure:
                "¿Cuál era el correo electrónico registrado en tu cuenta? Ingresa la dirección completa. Pista: {email}",
        },
        reset: {
            title: "Crea una nueva contraseña",
            info: "¡Ya casi! Ahora solo necesitas ingresar una nueva contraseña.",
            submit: "Cambiar mi contraseña",
            return_to: "Volver al inicio de sesión",
        },
        reseted_password_success: {
            title: "¡Éxito!",
            info: "Tu contraseña ha sido cambiada con éxito.",
        },
        reseted_password_error: {
            title: "¡Ups!",
            info: "Hubo un error al intentar cambiar tu contraseña, inténtalo de nuevo.",
        },
        reset_email: {
            title: "Registrar un nuevo correo electrónico",
            info: "¡Ya casi! Ahora solo necesitas registrar un nuevo correo electrónico para enviar el restablecimiento de contraseña.",
            submit: "Cambiar correo electrónico",
            return_to: "Volver al inicio de sesión",
        },
    },
    curriculum: {
        title: "Currículum",
        sections: {
            personal: {
                title: "Datos personales",
                address: "Datos de dirección",
                contacts: "Datos de contacto",
                required_contacts:
                    "Ingresa al menos un número de teléfono para contacto.",
                diversity: "Diversidad e Inclusión",
                diversity_subtitle:
                    "Valoramos la diversidad en el ambiente de trabajo, por eso tienes la libertad de proporcionar la siguiente información:",
                extra: "Campos adicionales",
                cnh: "Licencia Nacional de Conducir",
                login: "Tu inicio de sesión",
                bnt_ready: "Todo listo",
                confirm: "Confirmar",
                extra_by_company: "Campos adicionales de {company}",
            },
            parsing: {
                title: "Lector automático de CV",
                btn_upload_curriculum: "Rellénalo por mí - Importar Currículum",
            },
            professional: {
                title: "Datos profesionales",
                experiences: "Tus experiencias",
                objectives: "Objetivos",
                experience: "Trayectoria profesional",
                add_experience: "Añade tus experiencias profesionales",
            },
            education: {
                title: "Educación",
                academic: "Tu formación académica",
                training: "Formación complementaria",
                languages: "Idiomas",
                computing: "Conocimiento en informática",
            },
            dependents: {
                title: "Dependientes",
            },
            other_information: {
                title: "Otras informaciones",
            },
            additional: {
                title: "Información adicional",
            },
            presentation: {
                title: "Presentación",
            },
        },
        actions: {
            professional: {
                add_experience: "Añadir experiencia",
            },
            education: {
                add_academic: "Añadir formación académica",
                add_training: "Agregar curso o capacitación",
                add_language: "Añadir idioma",
            },
            dependents: {
                add_dependent: "Añadir dependiente",
            },
            transports: {
                add_transports: "Añadir transporte",
            },
        },

        texts: {
            professional: { activities: "Actividades" },
            education: {
                academic: {
                    time: {
                        morning: "Mañana",
                        afternoon: "Tarde",
                        night: "Noche",
                    },
                    period: { period: "No. - Periodo" },
                    situation: {
                        studying: "Estudiando",
                        completed: "Completado",
                        stopped: "Interrumpido",
                    },
                },
                none: "Ningún",
                basic: "Básico",
                intermediate: "Intermediario",
                advanced: "Avanzado",
                fluent: "Fluido",
            },
            dependents: {
                tokens: {
                    a: "Hijo(a) Válido",
                    b: "Hijo incapacitado para trabajar",
                    c: "Cónyuge",
                    d: "Padre",
                    e: "Madre",
                    f: "Suegro(a)",
                    g: "Otros",
                    h: "Abuelo(a)",
                    i: "Compañero(a)",
                    j: "Hijastro(a)",
                    k: "Excluido",
                    l: "Ex-cónyuge",
                    m: "Hermano(a) Válido",
                    n: "Hermano(a) incapacitado(a) para trabajar",
                    o: "Ex-compañero(a)",
                    p: "Ex-suegro(a)",
                    q: "Nieto(a)",
                    r: "Ex-hijastro(a)",
                },
            },
            personal: {
                pcd: {
                    not_informed: "No informado",
                    none: "Ninguna",
                    physical: "Física",
                    visual: "Visual",
                    auditive: "Auditiva",
                    intelectual: "Intelectual",
                    psicosocial: "Psicosocial",
                    autism: "Autismo",
                    multiple: "Múltiples",
                    rehabilitated: "Rehabilitado",
                },
                phone_with_areacode: "Ingrese el número de teléfono con código de área"
            },
        },
        sensitive: {
            login_username: {
                label: "Correo electrónico o CPF",
                placeholder: "",
                description: "",
            },
            new_primary_email: {
                label: "Nuevo Correo Electrónico",
                placeholder: "Ingrese un nuevo correo electrónico",
                description: "",
            },
            new_primary_email_confirmation: {
                label: "Confirmación de Correo Electrónico",
                placeholder: "Confirme su nuevo correo electrónico",
                description: "",
            },
            password: {
                label: "Contraseña",
                placeholder: "Ingrese su contraseña",
                description: "",
            },
            password_confirmation: {
                label: "Confirmación de Contraseña",
                placeholder: "Confirme la contraseña ingresada",
                description: "",
            },
            new_password: {
                label: "Nueva Contraseña",
                placeholder: "Cree una nueva contraseña",
                description: "",
            },
            new_password_confirmation: {
                label: "Confirmación de Nueva Contraseña",
                placeholder: "Confirme su nueva contraseña",
                description: "",
            },
        },
        personal: {
            is_foreigner: {
                label: "Soy Extranjero",
                placeholder: "",
                description: "",
            },
            origin_country: {
                label: "País de Origen",
                placeholder: "",
                description: "",
            },
            document_type_id: {
                label: "Documento de Identificación",
                placeholder: "",
                description: "",
            },
            document_number: {
                label: "Número de Documento",
                placeholder: "",
                description: "",
            },
            primary_email: {
                label: "Correo Electrónico",
                placeholder: "Proporcione su correo electrónico",
                description: "",
            },
            primary_email_confirmation: {
                label: "Confirmación de Correo Electrónico",
                placeholder: "Confirme su correo electrónico",
                description: "",
            },

            name: {
                label: "Nombre completo",
                placeholder: "Ingresa tu nombre completo",
                description: "",
            },
            assumed_name: {
                label: "Nombre social",
                placeholder: "",
                description: "",
            },
            photo3x4_file_id: {
                label: "Foto 3x4",
                placeholder: "",
                description: "",
            },
            cpf: {
                label: "CPF",
                placeholder: "Ingrese su CPF",
                description: "",
            },
            gender: {
                label: "Género",
                placeholder: "Sexo",
                description: "Esta información es obligatoria para el E-social.",
            },
            birth_date: {
                label: "Fecha de nacimiento",
                placeholder: "DD/MM/AAAA",
                description: "",
            },
            cellphone: {
                label: "Teléfono móvil",
                placeholder: "Teléfono móvil",
                description: "",
            },
            home_phone: {
                label: "Teléfono residencial",
                placeholder: "Teléfono residencial",
                description: "",
            },
            special_needs: {
                label: "Tiene alguna discapacidad",
                placeholder: "Seleccione",
                description: "",
            },
            special_needs_details: {
                label: "Especifique",
                placeholder: "Seleccione",
                description: "Descripción de PCD",
            },
            special_needs_file: {
                label: "Adjuntar informe",
                description: "Adjuntar informe/certificado de rehabilitación",
                placeholder: "Adjuntar informe",
            },
            rg: {
                label: "RG",
                placeholder: "RG",
                description: "",
            },
            state_rg: {
                label: "Estado Emisor RG",
                placeholder: "Estado Emisor RG",
                description: "",
            },
            organ_rg: {
                label: "Órgano Emisor RG",
                placeholder: "Órgano Emisor RG",
                description: "",
            },
            civil_status: {
                label: "Estado Civil",
                placeholder: "Estado Civil",
                description: "Esta información es obligatoria para el E-social.",
            },
            cnh_type: {
                label: "Tipo de CNH",
                placeholder: "Tipo de CNH",
                description: "",
            },
            children: {
                label: "Cantidad de hijos",
                placeholder: "Cantidad de hijos",
                description: "",
            },
            children_info: {
                label: "Información adicional sobre sus hijos",
                placeholder: "",
                description: "",
            },
            cellphone: {
                label: "Celular (con WhatsApp)",
                placeholder: "(00) 00000-0000",
                description: "",
            },
            home_phone: {
                label: "Teléfono residencial",
                placeholder: "Teléfono residencial",
                description: "",
            },

            business_phone: {
                label: "Teléfono comercial",
                placeholder: "Teléfono comercial",
                description: "",
            },
            message_with: {
                label: "Contacto para mensajes",
                placeholder: "Contacto para mensajes",
                description: "",
            },
            secondary_email: {
                label: "Correo electrónico secundario",
                placeholder: "Correo electrónico secundario",
                description: "",
            },
            site: {
                label: "sitio",
                placeholder: "sitio",
                description: "",
            },
            avatar: {
                label: "Foto de perfil",
                placeholder: "",
                description: "",
            },
            cv_external: {
                label: "Curiculum adjunto",
                placeholder: "",
                description: "",
            },
            cpf_file_id: {
                label: "Adjuntar CPF",
                placeholder: "",
                description: "",
            },
            city_rg: {
                label: "Ciudad de emisión RG",
                placeholder: "",
                description: "",
            },
            date_of_issue_rg: {
                label: "Fecha de expedición RG",
                placeholder: "",
                description: "",
            },
            rg_file_id: {
                label: "Adjunte RG (frente)",
                placeholder: "",
                description: "",
            },
            rg_file2_id: {
                label: "Adjuntar RG (atrás)",
                placeholder: "",
                description: "",
            },
            birth_file_id: {
                label: "Adjuntar certificado de nacimiento",
                placeholder: "",
                description: "",
            },
            nationality: {
                label: "Nacionalidad",
                placeholder: "",
                description: "",
            },
            born_state: {
                label: "Estado de nacimiento",
                placeholder: "",
                description: "",
            },
            born_city: {
                label: "Ciudad de nacimiento",
                placeholder: "",
                description: "",
            },
            mother_name: {
                label: "Nombre de la madre",
                placeholder: "",
                description: "",
            },
            mother_cpf: {
                label: "CPF de la madre",
                placeholder: "",
                description: "",
            },
            father_name: {
                label: "Nombre del Padre",
                placeholder: "",
                description: "",
            },
            father_cpf: {
                label: "CPF del padre",
                placeholder: "",
                description: "",
            },
            racial: {
                label: "Raza / color",
                placeholder: "",
                description: "",
            },
            national_health_service_number: {
                label: "Número de tarjeta SUS",
                placeholder: "",
                description: "",
            },
            national_health_service_number_file_id: {
                label: "Adjuntar tarjeta SUS",
                placeholder: "",
                description: "",
            },
            professional_number: {
                label: '"Número de registro profesional (Ej: CRM',
                placeholder: "",
                description: "",
            },
            professional_file_id: {
                label: "Adjuntar registro profesional",
                placeholder: "",
                description: "",
            },
            mother_name_not_declared_in_the_document:
                "Nombre de la madre no declarado en el documento",
            father_name_not_declared_in_the_document:
                "Nombre del padre no declarado en el documento",
        },
        address: {
            country: {
                label: "País",
                placeholder: "Seleccione el país",
                description: "",
            },
            zip_code: {
                label: "Código postal",
                placeholder: "Escriba su código postal",
                description: "",
            },
            street_type: {
                label: "Tipo de vía pública",
                placeholder: "Tipo de vía pública",
                description: "",
            },
            street: {
                label: "Vía pública",
                placeholder: "Vía pública",
                description: "",
            },
            number: {
                label: "Número",
                placeholder: "Número",
                description: "",
            },
            complement: {
                label: "Complemento",
                placeholder: "Complemento",
                description: "",
            },
            district: {
                label: "Vecindario",
                placeholder: "Vecindario",
                description: "",
            },
            state: {
                label: "Estado",
                placeholder: "Selecciona un Estado",
                description: "",
            },
            city: {
                label: "Ciudad",
                placeholder: "Seleccione una ciudad",
                description: "",
            },
            address_file_id: {
                label: "Comprobante de Residencia",
                placeholder: "",
                description: "",
            },
        },
        diversity: {
            racial: {
                label: "Étnico-racial",
                description:
                    "Esta información es obligatoria para el E-social.",
                placeholder: "",
            },
            assumed_name: {
                label: "Nombre Social",
                description: "Nombre con el que te identificas y eres reconocido socialmente.",
                placeholder: "",
            },
            gender_identity: {
                label: "Identidad de Género",
                description: "",
                placeholder: "",
            },
            gender_orientation: {
                label: "Orientación Sexual",
                description: "",
                placeholder: "",
            },
        },
        passport: {
            passport_number: {
                label: "Passport Number",
                description: "",
                placeholder: "",
            },
            passport_country: {
                label: "Passport Country",
                description: "",
                placeholder: "",
            },
            passport_date_emission: {
                label: "Passport Emission Date",
                description: "",
                placeholder: "",
            },
            passport_date_validity: {
                label: "Passport Validity Date",
                description: "",
                placeholder: "",
            },
        },
        professional: {
            intended_occupation: {
                label: "Puestos Deseados",
                placeholder: "",
                description: "(máx 3 puestos)",
            },
            interest_levels: {
                label: "Nivel de Interés",
                placeholder: "",
                description: "(máx 3 intereses)",
            },
            interest_areas: {
                label: "Área de Interés",
                placeholder: "",
                description: "(máx 3 áreas de interés)",
            },
            salary_intended: {
                label: "Pretensión Salarial",
                placeholder: "Pretensión salarial",
                description: "",
            },
            available_trip: {
                label: "¿Disponibilidad para viajar?",
                placeholder: "",
                description: "",
            },
            has_professional_history: {
                label: "¿Tiene experiencia profesional?",
                placeholder: "",
                description: "",
            },
            has_not_professional_history: {
                label: "No tengo experiencia",
                placeholder: "",
                description: "",
            },
            experiences: {
                company_id: {
                    label: "Empresa",
                    placeholder: "Empresa",
                    description: "",
                },
                company_name: {
                    label: "Empresa",
                    placeholder: "Empresa",
                    description: "",
                },
                occupation_id: {
                    label: "Puesto",
                    placeholder: "Puesto",
                    description: "",
                },
                start: {
                    label: "Inicio",
                    placeholder: "dd/mm/aaaa",
                    description: "",
                },
                finish: {
                    label: "Término",
                    placeholder: "dd/mm/aaaa",
                    description: "",
                },
                last_salary: {
                    label: "Último Salario",
                    placeholder: "Último salario",
                    description: "",
                },
                current_job: {
                    label: "Trabajo Actual",
                    placeholder: "Trabajo actual",
                    description: "",
                },
                acting_area: {
                    label: "Segmento",
                    placeholder: "Segmento",
                    description: "",
                },
                company_size: {
                    label: "Tamaño de la Empresa",
                    placeholder: "Tamaño de la empresa",
                    description: "",
                },
                activities: {
                    label: "Actividades Realizadas",
                    placeholder: "Actividades realizadas",
                    description: "",
                },
            },
        },
        education: {
            schooling_level: {
                label: "Nivel Educacional",
                description: "",
                placeholder: "Seleccione el nivel",
            },
            school_file_id: {
                label: "Adjuntar Certificado de Escolaridad",
                description: "",
                placeholder: "",
            },
            school_records_file1_id: {
                label: "Adjuntar Historial Académico (Frente)",
                description: "",
                placeholder: "",
            },
            school_records_file2_id: {
                label: "Adjuntar Historial Académico (Reverso)",
                description: "",
                placeholder: "",
            },
            has_schooling_level: {
                label: "¿Tiene formación académica?",
                placeholder: "",
                description: "",
            },
            has_not_academic_formation: {
                label: "No tengo escolaridad",
                placeholder: "",
                description: "",
            },
            has_computer_knowledge: {
                label: "¿Tiene conocimientos en informática?",
                placeholder: "",
                description: "",
            },
            has_languages: {
                label: "¿Tiene conocimientos en otros idiomas?",
                placeholder: "",
                description: "",
            },
            has_additional_training: {
                label: "¿Tiene cursos o capacitaciones complementarias?",
                placeholder: "",
                description: "",
            },
            academic: {
                education_level_id: {
                    label: "Nivel de educación",
                    description: "",
                    placeholder: "Seleccione el nivel",
                },
                course_id: {
                    label: "Curso",
                    description: "",
                    placeholder: "",
                },
                period: {
                    label: "Periodo",
                    description: "",
                    placeholder: "",
                },
                time: {
                    label: "Horario",
                    description: "",
                    placeholder: "",
                },
                institution: {
                    label: "Institución",
                    description: "",
                    placeholder: "Institución",
                },
                status: {
                    label: "Situación",
                    description: "",
                    placeholder: "Seleccione la situación",
                },
                start_date: {
                    label: "Fecha de inicio",
                    placeholder: "",
                    description: "",
                },
                conclusion_date: {
                    label: "Fecha de fin",
                    placeholder: "",
                    description: "",
                },
            },
            training: {
                additional_training_id: {
                    label: "Capacitación",
                    placeholder: "Capacitación",
                    description: "",
                },
                name: {
                    label: "Nombre del curso o capacitación",
                    placeholder: "Nombre del curso o capacitación",
                    description: "",
                },
                description: {
                    label: "Descripción de los conocimientos adquiridos",
                    placeholder: "Descripción de los conocimientos adquiridos",
                    description: "",
                },
                institution: {
                    label: "Institución",
                    placeholder: "Institución",
                    description: "",
                },
                status: {
                    label: "Situación",
                    placeholder: "Situación",
                    description: "",
                },
                start_date: {
                    label: "Período (inicio)",
                    placeholder: "Período (inicio)",
                    description: "",
                },
                finish_date: {
                    label: "Período (fin)",
                    placeholder: "Período (fin)",
                    description: "",
                },
            },
            languages: {
                language_id: {
                    label: "Lengua",
                    placeholder: "Lengua",
                    description: "",
                },
                speaking: {
                    label: "Habla",
                    placeholder: "Habla",
                    description: "",
                },
                writing: {
                    label: "Escribir",
                    placeholder: "Escribir",
                    description: "",
                },
                understanding: {
                    label: "Comprensión",
                    placeholder: "Comprensión",
                    description: "",
                },
                reading: {
                    label: "Lectura",
                    placeholder: "Lectura",
                    description: "",
                },
            },
        },
        computing: {
            title: "Informática",
            label: "",
            basic: {
                label: "Básico",
                placeholder: "Básico",
                description: "",
            },
            intermediate: {
                label: "Intermediario",
                placeholder: "Intermediario",
                description: "",
            },
            advanced: {
                label: "Avanzado",
                placeholder: "Avanzado",
                description: "",
            },
        },
        additional: {
            abroad_experience: {
                label: "Experiencia en el extranjero",
                placeholder: "Experiencia en el extranjero",
                description: "",
            },
            has_abroad_experience: {
                label: "Tiene experiencia en el extranjero",
                placeholder: "Tiene experiencia en el extranjero",
                description: "",
            },
            description: {
                label: "Descripción",
                placeholder: "Descripción",
                description: "",
            },
            complementary_activities: {
                label: "Actividades complementares",
                placeholder: "Actividades complementares",
                description: "",
            },
            sports: {
                label: "Deportes",
                placeholder: "Deportes",
                description: "",
            },
            hobby: {
                label: "Aficiones",
                placeholder: "Aficiones",
                description: "",
            },
            music: {
                label: "Música",
                placeholder: "Música",
                description: "",
            },
            passions: {
                label: "Pasiones",
                placeholder: "Pasiones",
                description: "",
            },
            books: {
                label: "Libros",
                placeholder: "Libros",
                description: "",
            },
            social_work: {
                label: "Trabajo Social",
                placeholder: "Trabajo Social",
                description: "",
            },
            extra_informations: {
                label: "Informaciones adicionales",
                placeholder: "Informaciones adicionales",
                description: "",
            },
            cover_letter: {
                label: "Carta de presentación",
                placeholder: "Carta de presentación",
                description: "",
            },
        },
        ctps: {
            has_ctps: {
                label: "¿Tiene permiso de trabajo?",
                placeholder: "",
                description: "",
            },
            is_first_job: {
                label: "¿Será tu primer trabajo formal?",
                placeholder: "",
                description: "",
            },
            ctps_type: {
                label: "¿Tipo de permiso de trabajo?",
                placeholder: "",
                description: "",
            },
            ctps_number: {
                label: "Número CTPS",
                placeholder: "",
                description: "",
            },
            ctps_serial: {
                label: "Serie CTPS",
                placeholder: "",
                description: "",
            },
            ctps_state: {
                label: "Estado de CTPS",
                placeholder: "",
                description: "",
            },
            ctps_city: {
                label: "Ciudad de CTPS",
                placeholder: "",
                description: "",
            },
            ctps_date: {
                label: "Emisión de fecha de CTPS",
                placeholder: "",
                description: "",
            },
            ctps_file_id: {
                label: "Adjunte CTPS (frente)",
                placeholder: "",
                description: "",
            },
            ctps_file2_id: {
                label: "Adjuntar CTPS (Atrás)",
                placeholder: "",
                description: "",
            },
            ctps_file3_id: {
                label: "Adjunte el último registro de CTPS",
                placeholder: "",
                description: "",
            },
            has_pis: {
                label: "¿Tienes pis?",
                placeholder: "",
                description: "",
            },
            pis_pasep_number: {
                label: "Número de pis/pasep",
                placeholder: "",
                description: "",
                help: "<a href='https://selecty.movidesk.com/kb/pt-br/article/455803/8-maneiras-de-localizar-seu-pis' target='_blank'>dónde encontrar el número PIS</a>",
            },
            pis_pasep_date: {
                label: "Datos de PIS/PASEP",
                placeholder: "",
                description: "",
            },
            pis_file_id: {
                label: "Adjuntar PIS",
                placeholder: "",
                description: "",
            },
        },
        voter: {
            has_voter_registration: {
                label: "¿Tiene título de elector?",
                placeholder: "",
                description: "",
            },
            voter_registration_number: {
                label: "Número",
                placeholder: "",
                description: "",
            },
            voter_registration_zone: {
                label: "Zona",
                placeholder: "",
                description: "",
            },
            voter_registration_section: {
                label: "Sección",
                placeholder: "",
                description: "",
            },
            voter_registration_state: {
                label: "Estado",
                placeholder: "",
                description: "",
            },
            voter_registration_city: {
                label: "Ciudad",
                placeholder: "",
                description: "",
            },
            voter_registration_date: {
                label: "Fecha de emisión",
                placeholder: "",
                description: "",
            },
            voter_registration_file_id: {
                label: "Adjunte el título de elector (frente)",
                placeholder: "",
                description: "",
            },
            voter_registration_file2_id: {
                label: "Adjunte el título de elector (atrás)",
                placeholder: "",
                description: "",
            },
        },
        armed_forces: {
            has_certificate_armed_forces: {
                label: "¿Posee Certificado de Reservista?",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_status: {
                label: "Situación",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service: {
                label: "RA Número",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_serie: {
                label: "Serie",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_organ: {
                label: "Órgano",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_uf: {
                label: "UF",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_type: {
                label: "Tipo",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_category: {
                label: "Categoría",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_service_date: {
                label: "Fecha de emisión",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_file_id: {
                label: "Adjunte el certificado de reservista (frente)",
                placeholder: "",
                description: "",
            },
            certificate_of_armed_forces_file2_id: {
                label: "Adjunte el certificado de reservista (atrás)",
                placeholder: "",
                description: "",
            },
        },
        cnh: {
            has_cnh: {
                label: "¿Tienes carnet de conducir?",
                placeholder: "",
                description: "",
            },
            cnh_number: {
                label: "Número",
                placeholder: "",
                description: "",
            },
            cnh_local: {
                label: "Local",
                placeholder: "",
                description: "",
            },
            cnh_organ: {
                label: "Órgano emisor",
                placeholder: "",
                description: "",
            },
            cnh_state: {
                label: "Estado de emisión",
                placeholder: "",
                description: "",
            },
            cnh_type: {
                label: "Tipo de CNH",
                placeholder: "",
                description: "",
            },
            cnh_date_emission: {
                label: "Fecha de emisión",
                placeholder: "",
                description: "",
            },
            cnh_date_validity: {
                label: "Fecha de validez",
                placeholder: "",
                description: "",
            },
            cnh_date_first_emission: {
                label: "Primera emisión",
                placeholder: "",
                description: "",
            },
            cnh_file_id: {
                label: "Adjunte CNH (frente)",
                placeholder: "",
                description: "",
            },
            cnh_file_2_id: {
                label: "Adjunte CNH (atrás)",
                placeholder: "",
                description: "",
            },
        },
        bank: {
            has_bank: {
                label: "¿Tiene una cuenta bancaria a su nombre?",
                placeholder: "",
                description: "",
            },
            bank_name: {
                label: "Nombre del banco",
                placeholder: "",
                description: "",
            },
            bank_type: {
                label: "Tipo de cuenta",
                placeholder: "",
                description: "",
            },
            bank_holder_name: {
                label: "Nombre del titular",
                placeholder: "",
                description: "",
            },
            bank_holder_type: {
                label: "Tipo de Titular",
                placeholder: "",
                description: "",
            },
            bank_agency: {
                label: "Agencia",
                placeholder: "",
                description: "",
            },
            bank_account: {
                label: "Cuenta",
                placeholder: "",
                description: "",
            },

            bank_operation: {
                label: "Operación bancaria",
                placeholder: "",
                description: "",
            },
            account_file_id: {
                label: "Adjunte la cuenta bancaria de prueba (frente)",
                placeholder: "",
                description: "",
            },
            account_file2_id: {
                label: "Adjunte la cuenta bancaria de prueba (atrás)",
                placeholder: "",
                description: "",
            },
            bank_pix_type: {
                label: "Tipo de clave Pix",
                placeholder: "",
                description: "",
            },
            bank_pix_value: {
                label: "Clave PIX",
                placeholder: "",
                description: "",
            },
        },
        dependents: {
            name: {
                label: "Nombre completo",
                placeholder: "",
                description: "",
            },
            birth_date: {
                label: "Fecha de nacimiento",
                placeholder: "",
                description: "",
            },
            gender: {
                label: "Sexo",
                placeholder: "",
                description: "",
            },
            civil_status: {
                label: "Estado civil",
                placeholder: "",
                description: "",
            },
            kinship: {
                label: "Grado de parentesco",
                placeholder: "",
                description: "",
            },
            rg: {
                label: "RG",
                placeholder: "",
                description: "",
            },
            cpf: {
                label: "CPF",
                placeholder: "",
                description: "",
            },
            vaccine_number: {
                label: "Cartilla de vacunación",
                placeholder: "",
                description: "",
            },
            sus_card: {
                label: "Número de tarjeta SUS",
                placeholder: "",
                description: "",
            },
            mother_name: {
                label: "Nombre de la madre",
                placeholder: "",
                description: "",
            },
            income_tax: {
                label: "¿Quieres declararlo en tu impuesto sobre la renta?",
                placeholder: "",
                description: "",
            },
            life_insurance: {
                label: "¿Incluir a ese dependiente como beneficiario de su seguro de vida?",
                placeholder: "",
                description: "",
            },
            health_care: {
                label: "¿Incluir a este dependiente en el plan de asistencia médica?",
                placeholder: "",
                description: "",
            },
            file_1_id: {
                label: "Adjuntar certificado de nacimiento (frente)",
                placeholder: "",
                description: "",
            },
            file_2_id: {
                label: "Adjuntar certificado de nacimiento (atrás)",
                placeholder: "",
                description: "",
            },
            file_3_id: {
                label: "Adjunte CPF del dependiente",
                placeholder: "",
                description: "",
            },
            file_4_id: {
                label: "Adjuntar declaración de matriculación escolar",
                placeholder: "",
                description: "",
            },
            file_5_id: {
                label: "Adjuntar prueba de matrícula universitaria",
                placeholder: "",
                description: "",
            },
            file_6_id: {
                label: "Adjuntar Declaración de Dependencia Económica Registrada ante Notario",
                placeholder: "",
                description: "",
            },
            file_7_id: {
                label: "Adjuntar un acuerdo de tutela",
                placeholder: "",
                description: "",
            },
            file_8_id: {
                label: "Adjuntar la cartilla de vacunación (frente)",
                placeholder: "",
                description: "",
            },
            file_9_id: {
                label: "Ajuste de la tarjeta SUS",
                placeholder: "",
                description: "",
            },
            file_10_id: {
                label: "Adjuntar la cartilla de vacunación (atrás)",
                placeholder: "",
                description: "",
            },
            file_11_id: {
                label: "Adjuntar RG",
                placeholder: "",
                description: "",
            },
            file_12_id: {
                label: "Adjuntar certificado de matrimonio",
                placeholder: "",
                description: "",
            },
            file_13_id: {
                label: "Adjuntar informe PCD",
                placeholder: "",
                description: "",
            },
            file_14_id: {
                label: "Adjuntar expediente académico",
                placeholder: "",
                description: "",
            },
            file_15_id: {
                label: "Adjuntar RG (atrás)",
                placeholder: "",
                description: "",
            },
        },
        epi: {
            tshirt: {
                label: "Camiseta",
                placeholder: "",
                description: "",
            },
            trousers: {
                label: "Pantalón",
                placeholder: "",
                description: "",
            },
            shoe: {
                label: "Calzado",
                placeholder: "",
                description: "",
            },
            jacket: {
                label: "Chaqueta",
                placeholder: "",
                description: "",
            },
            shirt: {
                label: "Camisa",
                placeholder: "",
                description: "",
            },
        },
        benefits: {
            benefits: {
                label: "Seleccione los beneficios que desea recibir",
                placeholder: "",
                description: "",
            },
            has_transports: {
                label: "¿Necesita vale de transporte?",
                placeholder: "",
                description: "",
            },
        },
        transports: {
            way_transport: {
                label: "Itinerario",
                description: "",
                placeholder: "",
            },
            type_transport: {
                label: "Tipo de Transporte",
                description: "",
                placeholder: "",
            },
            path_transport: {
                label: "Ruta",
                description: "",
                placeholder: "Ej: Línea Roja del Metro (Corinthians-Itaquera)",
            },
            value_transport: {
                label: "Valor del pasaje (R$)",
                description: "",
                placeholder: "",
            },
        },

        cnpj: {
            has_cnpj: {
                label: "¿Tiene una entidad jurídica?",
                placeholder: "",
                description: "",
            },
            cnpj_name: {
                label: "Razón social",
                placeholder: "",
                description: "",
            },
            cnpj_number: {
                label: "CNPJ",
                placeholder: "",
                description: "",
            },
        },
        contacts: {
            contact_name1: {
                label: "Nombre 1",
                placeholder: "",
                description: "",
            },
            contact_phone1: {
                label: "Teléfono 1",
                placeholder: "",
                description: "",
            },
            contact_name2: {
                label: "Nombre 2",
                placeholder: "",
                description: "",
            },
            contact_phone2: {
                label: "Teléfono 2",
                placeholder: "",
                description: "",
            },
        },
        forms: {
            transport_form_file_id: {
                label: "Adjuntar formulario de cupón de transporte",
                placeholder: "",
                description: "",
            },
            transport_file_id: {
                label: "Copia de la Tarjeta de cupón de Transporte",
                placeholder: "",
                description: "",
            },
            chartered_file_id: {
                label: "Formulario",
                placeholder: "",
                description: "",
            },
            salary_family_file_id: {
                label: "Formulario de salario familiar",
                placeholder: "",
                description: "",
            },
            impost_file_id: {
                label: "Adjuntar formulario del impuesto sobre la renta",
                placeholder: "",
                description: "",
            },
            has_contribution_sindical: {
                label: "¿Desea realizar su contribución sindical?",
                placeholder: "",
                description: "",
            },
            syndicate_contribution_file_id: {
                label: "Adjuntar Declaración de Adhesión a la Contribución Sindical",
                placeholder: "",
                description: "",
            },
            vaccine_file_id: {
                label: "Adjuntar Otros",
                placeholder: "",
                description: "",
            },
            unemployment_insurance_file_id: {
                label: "Adjuntar prueba del seguro de desempleo",
                placeholder: "",
                description: "",
            },
            contribution_inss_file_id: {
                label: "Adjuntar prueba de cotización al INSS",
                placeholder: "",
                description: "",
            },
            other_file_id: {
                label: "Adjuntar Otros",
                placeholder: "",
                description: "",
            },
            other_file2_id: {
                label: "Adjuntar Otros",
                placeholder: "",
                description: "",
            },
            other_file3_id: {
                label: "Adjuntar Otros",
                placeholder: "",
                description: "",
            },
            other_file4_id: {
                label: "Adjuntar Otros",
                placeholder: "",
                description: "",
            },
        },
    },
    admissional: {
        fill: "Relleno",
        section: 'Sección',
        title: "Formulario de Admisión",
        sections: {
            personal: {
                title: "Información Básica",
                address: "Información de Dirección",
                education: "Información Académica",
                diversity: "Diversidad e Inclusión",
            },
            ctps: {
                title: "Tarjeta de Trabajo",
            },
            voter: {
                title: "Registro de Votante",
            },
            armed_forces: {
                title: "Certificado de Reservista",
            },
            cnh: {
                title: "Licencia de Conducir",
            },
            bank: {
                title: "Detalles Bancarios",
                generate_bank_letter:
                    "Genera tu carta para abrir una cuenta bancaria aquí",
            },
            dependents: {
                title: "Dependientes",
            },
            transports: {
                title: "Transporte",
            },
            epi: {
                title: "EPP/Uniforme",
            },
            benefits: {
                title: "Beneficios",
            },
            cnpj: {
                title: "Detalles de la Entidad Legal",
            },
            contacts: {
                title: "Contactos de Emergencia",
            },
            forms: {
                title: "Otros Documentos",
            },
        },
    },
    complementary_data: {
        title: "Datos Complementarios",
    },
    esocial: {
        title: "Registro E-social",
    },
    admission_data: {
        title: "Datos de Admisión",
    },
    vacancy: {
        "no-vacancy": "No hay vacantes para mostrar",
        filters: {
            text: {
                label: "",
                placeholder: "Buscar trabajo por cargo o empresa",
                description: "",
                occupation: "Puesto",
                interest_area: "Área Profesional",
                activities: "Actividades",
                requirements: "Requisitos",
            },
            location: {
                label: "",
                placeholder: "Ubicación",
                description: "",
                vacancies_at: "Vacantes en:",
            },
            interval: {
                label: "",
                placeholder: "Data de publicación",
                description: "",
                tokens: {
                    anyTime: "Todos",
                    lastDay: "Últimas 24 horas",
                    lastThreeDays: "Últimos 3 días",
                    lastWeek: "Semana anterior",
                    lastMonth: "Mes anterior",
                },
                action_buttons: {
                    redefine: "Redefinir",
                    see_results: "Ver resultados"
                }
            },
            positions: {
                label: "",
                placeholder: "",
                description: "",
                tokens: {
                    all: "Todos",
                    oneOrMore: "Más de 1 vacante",
                    fiveOrMore: "Más de 5 vacantes",
                    TenOrMore: "Más de 10 vacantes",
                },
            },
            contract_type: {
                label: "",
                placeholder: "Tipo de puesto",
                description: "",
                tokens: {
                    all: "Todos",
                    autonomous: "Autónomo",
                    clt: "CLT ( Tiempo completo)",
                    freeLance: "Trabajador autónomo",
                    juridicPerson: "Contratista",
                    temporary: "Temporal",
                    trainee: "Becario",
                    internship: "Estudiante en prácticas",
                    apprentice: "Aprendiz junior",
                    diarist: "Trabajador por horas",
                    cooperated: "Cooperativa",
                    outsourced: "Subcontratación",
                },
            },
            workplace_type: {
                label: "",
                placeholder: "Remoto",
                description: "",
                tokens: {
                    all: "Todas las modalidades de vacante",
                    presential: "In situ",
                    hybrid: "Híbrido",
                    homeOffice: "Remoto",
                    extern: "Exterior",
                },
            },
            professional_area: {
                label: "",
                placeholder: "Industria",
                description: "",
                tokens: {
                    all: "Todas las áreas profesionales",
                    interest_areas_1: "Administración Comercial/Ventas",
                    interest_areas_2: "Administración de Empresas",
                    interest_areas_3: "Administración Pública",
                    interest_areas_4: "Abogacía/Jurídica",
                    interest_areas_5: "Agrícola",
                    interest_areas_6: "Agronomía",
                    interest_areas_7: "Alimentos y Bebidas",
                    interest_areas_8: "Arquitectura/Urbanismo",
                    interest_areas_9: "Archivística",
                    interest_areas_10: "Artes Escénicas",
                    interest_areas_11: "Artes Gráficas",
                    interest_areas_12: "Artes Plásticas",
                    interest_areas_13:
                        "Atención al cliente - Bares y Restaurantes",
                    interest_areas_14:
                        "Atención al cliente - Telefonistas/Recepcionistas",
                    interest_areas_15:
                        "Atención al cliente - Telemarketing/Centro de Llamadas",
                    interest_areas_16: "Atención al cliente",
                    interest_areas_17: "Auditoría",
                    interest_areas_18: "Automatización Industrial",
                    interest_areas_19: "Automovilística",
                    interest_areas_20: "Bancos",
                    interest_areas_21: "Biblioteconomía",
                    interest_areas_22: "Biología/Ciencias Biológicas",
                    interest_areas_23: "Biomedicina",
                    interest_areas_24: "Biotecnología/Bioprocesos",
                    interest_areas_25: "Captación y Fomento",
                    interest_areas_26: "Ciencias Sociales",
                    interest_areas_27: "Cine",
                    interest_areas_28: "Comercio Exterior",
                    interest_areas_29: "Compras",
                    interest_areas_30: "Comunicación",
                    interest_areas_31: "Confección",
                    interest_areas_32: "Construcción Civil",
                    interest_areas_33: "Contabilidad",
                    interest_areas_34: "Controladoria",
                    interest_areas_35: "Cocina/Gastronomía",
                    interest_areas_36: "Cultura",
                    interest_areas_37: "Diseño Industrial",
                    interest_areas_38: "Desarrollo de Negocios",
                    interest_areas_39: "Diseño de Interiores",
                    interest_areas_40: "Diseño Gráfico",
                    interest_areas_41: "Ecología/Medio Ambiente",
                    interest_areas_42: "Economía",
                    interest_areas_43: "Educación",
                    interest_areas_44: "Electroeletrónica",
                    interest_areas_45: "Emprendimiento Juvenil",
                    interest_areas_46: "Enfermería",
                    interest_areas_47: "Enfermería - del Trabajo",
                    interest_areas_48: "Ingeniería de Alimentos",
                    interest_areas_49: "Ingeniería Civil",
                    interest_areas_50: "Ingeniería Electrónica",
                    interest_areas_51: "Ingeniería Electrotécnica",
                    interest_areas_52: "Ingeniería Mecánica",
                    interest_areas_53: "Ingeniería Metalúrgica y de Materiales",
                    interest_areas_54: "Ingeniería de Minas",
                    interest_areas_55: "Ingeniería de Producción",
                    interest_areas_56: "Ingeniería Química",
                    interest_areas_57: "Ingeniería - Otras",
                    interest_areas_58: "Educación Superior e Investigación",
                    interest_areas_59: "Educación - Enseñanza Media / Técnica",
                    interest_areas_60: "Educación - Enseñanza Primaria",
                    interest_areas_61: "Educación - Enseñanza Infantil",
                    interest_areas_62: "Educación - Enseñanza a Distancia",
                    interest_areas_63: "Enseñanza - Otros",
                    interest_areas_64: "Entretenimiento",
                    interest_areas_65: "Deportes",
                    interest_areas_66: "Estética",
                    interest_areas_67: "Eventos",
                    interest_areas_68: "Farmacia",
                    interest_areas_69: "Filosofía",
                    interest_areas_70: "Finanzas",
                    interest_areas_71: "Fiscal",
                    interest_areas_72: "Física",
                    interest_areas_73: "Fisioterapia",
                    interest_areas_74: "Forestal",
                    interest_areas_75: "Fonoaudiología",
                    interest_areas_76: "Geografía",
                    interest_areas_77: "Geología",
                    interest_areas_78: "Gestión Empresarial",
                    interest_areas_79: "Gestión de Proyectos",
                    interest_areas_80: "Gráfica y Editorial",
                    interest_areas_81: "Historia",
                    interest_areas_82: "Hotelaria",
                    interest_areas_83: "Industrial",
                    interest_areas_84: "Informática/T.I.",
                    interest_areas_85: "Innovación",
                    interest_areas_86: "Internet",
                    interest_areas_87: "Periodismo",
                    interest_areas_88: "Ocio",
                    interest_areas_89: "Letras",
                    interest_areas_90: "Logística",
                    interest_areas_91: "Madera y Mobiliario",
                    interest_areas_92: "Mantenimiento Industrial",
                    interest_areas_93: "Mantenimiento de Edificios",
                    interest_areas_94: "Marketing",
                    interest_areas_95: "Matemáticas/Estadística",
                    interest_areas_96: "Mecatrónica",
                    interest_areas_97: "Medicina/Hospitalaria",
                    interest_areas_98: "Metalúrgica",
                    interest_areas_99: "Meteorología",
                    interest_areas_100: "Medios Educativos",
                    interest_areas_101: "Minería",
                    interest_areas_102: "Minerales no Metálicos",
                    interest_areas_103: "Moda",
                    interest_areas_104: "Museología",
                    interest_areas_105: "Música",
                    interest_areas_106: "Nutrición",
                    interest_areas_107: "Oceanografía",
                    interest_areas_108: "Odontología",
                    interest_areas_109: "Presupuesto",
                    interest_areas_110:
                        "Organización de Eventos/Producción Cultural",
                    interest_areas_111: "Organización y Métodos",
                    interest_areas_112: "Papel y Celulosa",
                    interest_areas_113: "Patrimonio - Gestión",
                    interest_areas_114: "Investigación de Mercado",
                    interest_areas_115: "Petrolera",
                    interest_areas_116: "Plásticos y Polímeros",
                    interest_areas_117: "Producción/Fabricación",
                    interest_areas_118: "Publicidad",
                    interest_areas_119: "Psicología",
                    interest_areas_120: "Calidad",
                    interest_areas_121: "Química",
                    interest_areas_122: "Radialismo y Televisión",
                    interest_areas_123: "Recursos Humanos",
                    interest_areas_124: "Refrigeración y Climatización",
                    interest_areas_125: "Relaciones Internacionales",
                    interest_areas_126: "Relaciones Públicas",
                    interest_areas_127: "Responsabilidad Social",
                    interest_areas_128: "Secretariado",
                    interest_areas_129: "Seguridad y Salud en el Trabajo",
                    interest_areas_130: "Seguridad Patrimonial",
                    interest_areas_131: "Seguros",
                    interest_areas_132: "Servicio Social",
                    interest_areas_133: "Servicios Administrativos",
                    interest_areas_134: "Servicios Domésticos",
                    interest_areas_135: "Servicios Especializados - Carnicería",
                    interest_areas_136:
                        "Servicios Especializados - Panadería/Confitería",
                    interest_areas_137: "Servicios Especializados - Pescadería",
                    interest_areas_138: "Servicios Generales",
                    interest_areas_139: "Servicios Técnicos - Eléctricos",
                    interest_areas_140: "Servicios Técnicos - Electrónicos",
                    interest_areas_141: "Servicios Técnicos - Mecánicos",
                    interest_areas_142: "Servicios Técnicos - Otros",
                    interest_areas_143: "Suministros",
                    interest_areas_144: "Telecomunicaciones",
                    interest_areas_145: "Terapia Ocupacional",
                    interest_areas_146: "Tercer Sector/Responsabilidad Social",
                    interest_areas_147: "Traducción/Interpretación",
                    interest_areas_148: "Transporte - Gestión",
                    interest_areas_149: "Transporte Aéreo",
                    interest_areas_150: "Transporte Marítimo",
                    interest_areas_151: "Transporte Terrestre",
                    interest_areas_152: "Transporte Ferroviario",
                    interest_areas_153:
                        "Entrenamiento y Orientación Profesional",
                    interest_areas_154: "Tributaria",
                    interest_areas_155: "Turismo",
                    interest_areas_156: "Ventas",
                    interest_areas_157: "Ventas - Retail",
                    interest_areas_158: "Ventas Técnicas",
                    interest_areas_159: "Veterinaria",
                    interest_areas_160: "Viajes",
                    interest_areas_161: "Diseño Web",
                    interest_areas_162: "Zoología",
                    interest_areas_163: "Zootecnia",
                    interest_areas_164: "Trade Marketing",
                },
            },
            companies: {
                label: "",
                placeholder: "Empresas",
                description: "",
            },
            tags: {
                label: "",
                placeholder: "Tags",
                description: "",
            },

            results:
                "Ningún resultado encontrado | <b>{count} vacante</b> encontrada | <b>{count} vacantes</b> encontradas",
            with_positions: "totalizando <b>{count} posición</b> | totalizando <b>{count} posiciones</b>",
            count_paginated_results: "Mostrando {count} de ",
            count_all_results: "{count} resultados",
        },
        share: {
            title: "Compartir",
            tw: { label: "Twitter" },
            fb: { label: "Facebook" },
            lk: { label: "LinkedIn" },
            whatsapp: { label: "WhatsApp" },
        },
        actions: {
            share: "Compartir",
            apply: "Candidatarse",
            "already-applied": "Candidatura enviada",
            "see-vacancy": "Ver vacante",
            seeAllVacancies: "Ver todos",
            seeOurVacancies: "Ver todos los puestos disponibles",
            seeOpenPositions: "Ver puestos disponibles!",
            copy: "Copiar",
            save: "Guardar",
            favorite: "Agregar a favoritos",
            unfavorite: "Eliminar de favoritos",
            saved: "Guardada",
            favorite_success: "Vacante añadida a favoritos con éxito!",
            please_login_to_favorite:
                "¡Inicia sesión para agregar la vacante a favoritos!",
            favorite_failure: "¡Error al agregar la vacante a favoritos!",
            none_favorite_vacancy: "Sin vacantes favoritas",
            almost_there: "¡Casi lo logras!",
            needed_information_to_complete:
                "La información a continuación es necesaria para completar tu candidatura.",
            keep_looking_vacancies:
                "Echa un vistazo a más oportunidades y agrega a tu lista de favoritas las que mejor se adapten a tu perfil.",
            save_vacancy: "Guardar vacante",
            log_to_save: "Inicia sesión para poder guardar esta vacante",
            log_to_apply: "Inicia sesión para poder postularte a esta vacante",
            remove_favorite: "Eliminar vacante de favoritos",
        },
        texts: {
            pcd: {
                info: "Vacantes destinadas a personas con discapacidad",
            },
        },
        shareJob: "Comparte esta vacante",
        codVacancy: "Cód. de la Vacante:",
        jobsQuantity: "Número de vacantes:",
        contract_type: "Tipo de contratación: ",
        interest_area: "Área profesional : ",
        workload: "Carga horaria: ",
        work_schedule: "Jornada de trabajo: ",
        salary: "Salario: ",
        copyLink: "O copia el enlace",
        location: "Ubicación: ",
        company: "Empresa",
        pcd: "¿Vacante PCD?",
        workplace_type: "Modalidad de trabajo: ",
        process_type: "Tipo de proceso: ",
        pcdInfo: "Tipos de PCD:",
        search: "Buscar",
        lastDay: "Últimas 24 horas",
        lastThreeDays: "Últimos 3 días",
        lastWeek: "Última semana",
        lastMonth: "Últimos 30 días",
        anyTime: "En cualquier momento",
        moreThan: "más de ",
        anyJobsQuantity: "Cualquier cantidad de vacantes",
        cleanFilters: "Restablecer",
        jobs: "vacantes",
        apply: "Candidatarse",
        about: "Sobre nosotros",
        vacancy_info: "Datos de la vacante",
        responsabilities: "Responsabilidades y atribuciones",
        requirements: "Requisitos y cualificaciones",
        desirable: "Deseable",
        benefits: "Beneficios",
        additional_info: "Información adicional",
        keep_searching:
            "Sigue buscando y prueba otros términos y filtros para encontrar la vacante ideal para ti.",
        empty_vacancy: "Ninguna vacante encontrada",
        vacancy_not_found: "Vacante no encontrada",
        published_at: " Publicada hace ",
        published_days: "día | días",
        days_ago: "",
        published_at_x_days: " N/A|Publicada hace {n} día|Publicada hace {n} días",
        published_hours: "N/A|1 hora|{count} horas",
        vacancies: "vacante | vacantes",
        positions: "posición | posiciones"
    },
    vacancy_by_city: "Vacantes por ciudad",
    vacancy_by_area: "Vacantes por área",
    vacancy_by_occupation: "Vacantes por ocupación",
    home: {
        sections: {
            vacancies: {
                title: "Vacantes destacadas",
            },
        },
        resume: "Currículo",
        "active-vacancies":
            "Sin vacantes | 1 vacante activa | {count} vacantes activas",
        "pending-items": "Sin pendientes | 1 pendiente | {count} pendientes",
        "unread-messages": "1 no leída | {count} no leídas",

        completeness: "completado",
        messages: "Mensajes",
        welcome_msg: "Bienvenido a la página principal",
        hi: "Hola",
        follow: "seguir",
        currentJobs: "Estás participando en",
        jobs: "vacantes",
        profileJobs: "Vacantes que se adaptan a tu perfil",
        appointments: "Citas",
        curriculum: {
            empty: "Tu currículo está un poco vacío",
            half: "Te falta poco para completar tu currículo",
            full: "Tu currículo está completo",
            complete: "Completar tu currículo",
            review: "Revisar currículo",
            follow: "Seguir",
        },
        more_than: "Más de",
        job_opportunities: "oportunidades de empleo!",
        success_key: "Selecty Jobs como llave del éxito",
        supportive_partner: "Aquí tienes un partner para apoyarte en este momento tan importante, ¡la búsqueda de tu próximo empleo!",
        free_for_candidates: "100% gratuito para los candidatos",
        unlimited_applications: "Aplicaciones ilimitadas",
        meaningful_stages: "Sólo etapas de entrevista significativas",
        real_jobs: "Trabajos reales en empresas reales",
        profile_visibility: "¡Tu perfil profesional visto y consultado por millares de empresas!"
    },
    registration: {
        placeholders: {
            "email-or-cpf": "",
        },
        hello: "Hola, {0}",
        lets_go: "Vamos, {0}",
        congratulations_text: "¡Qué bueno que encontraste una oportunidad!",
        account_not_found:
            "No encontramos una cuenta registrada para este CPF, ¿deseas registrarte?",
        candidacy_start: "Vamos a iniciar tu candidatura",
        create_mini_curriculum: "Completa tu mini currículum para continuar",
        hasAccount: "¿Ya tienes una cuenta?",
        login: "Conéctese aquí",
        fullName: "Nombre completo",
        typeFullName: "Escribe tu nombre completo",
        createPassword: "Crea una contraseña",
        lowerLetter: "Una letra minúscula",
        upperLetter: "Una letra mayúscula",
        number: "Un número",
        specialChar: "Un carácter especial",
        eightChars: "Mínimo 8 caracteres",
        agree_with: "Al hacer clic en comenzar, aceptas",
        as: "las",
        specific_policies: "Políticas Específicas",
        from_company: "de la empresa",
        os: "las",
        terms_and_conditions: "Términos y Condiciones",
        and_the: "y la",
        privacy_policy: "Política de Privacidad",
        from_selecty_platform: "de la plataforma Selecty",
        continue: "Continuar",
        start: "Empezar ya",
        createAccount: "Acepta y regístrate",
        confirmPassword: "Confirma tu contraseña",
        finish_your_account_creation: "Finaliza la creación de tu cuenta",
        you_need_your_account_to_check:
            "La necesitas para seguir tus candidaturas",
        lets_create_your_password: "Vamos a crear tu contraseña",
        you_will_need_it_to_access_your_account: "La necesitarás para acceder a tu cuenta"
    },
    communication: {
        confirmation:
            "Recibimos tu solicitud y la analizaremos tan pronto como sea posible.",
        error: "Ocurrió un error al enviar tu solicitud, intenta de nuevo más tarde.",
        almost_done: "¡Estamos casi allí!",
        invalid_token: {
            title: "¡Error!",
            text: "¡Token inválido! Intenta de nuevo más tarde.",
        },
        request_sent: {
            title: "¡Todo correcto!",
            text: "¡Gracias! Recibimos tu solicitud y la analizaremos tan pronto como sea posible.",
        },
        email_confirm: {
            title: "¡Estamos casi allí!",
            text: "Hemos enviado un enlace de verificación a tu correo electrónico para poder registrar el contacto, el enlace tiene una validez de 15 minutos.",
        },
    },
    confirm_communication: {
        loading: {
            title: "Estamos registrando tu contacto",
            text: "Por favor espera...",
        },
    },
    feedback: {
        communication: {
            success: "¡Muchas gracias! Recibimos tu retroalimentación.",
            confirmation:
                "Por favor, confirma tu correo electrónico para registrar tu contacto.",
        },
        modal: {
            title: "Nos gustaría pedirte tu colaboración contándonos cómo fue tu experiencia.",
            question_1: "De 0 a 5, ¿cómo calificas la facilidad para registrar tus datos?",
            question_2: "De 0 a 5: ¿Cómo calificas la claridad de la información?",
            question_3: "De 0 a 5: ¿Cómo valoras la información encontrada sobre tu candidatura?"
        },
        rating_0: {
            name: "rating_0",
            label: "",
        },
        rating_1: {
            name: "rating_1",
            label: "",
        },
        rating_2: {
            name: "rating_2",
            label: "",
        },
        feedback_scale_labels: {
            very_hard: "Muy difícil",
            hard: "Difícil",
            medium: "Medio",
            easy: "Fácil",
            very_easy: "Muy fácil"
        },
        results: {
            default: "Cuéntanos cómo fue tu experiencia",
            bad: "¡Qué pena 🙁! Cuéntanos cómo fue tu experiencia",
            good: "¡Qué genial 😄! Cuéntanos cómo fue tu experiencia"
        },                        
    },
    help: {
        button: {
            message: "¿Necesitas ayuda?",
        },
        communication: {
            success:
                "Hemos recibido tu consulta. Te contactaremos tan pronto como sea posible.",
            confirmation:
                "Por favor, confirma tu correo electrónico para registrar tu contacto.",
        },
        modal: {
            title: "Dudas, Sugerencias, por favor contáctanos",
        },
        message: {
            name: "Mensaje",
            placeholder: "Deja tu mensaje",
            label: "Cuéntanos qué sucedió",
            description:
                "Prometemos no utilizar tu información de contacto para enviar ningún tipo de SPAM.",
        },
        confirmation_mail: {
            title: "¡Gracias por confirmar tu correo electrónico!",
        },
    },
    messages: {
        search: "Buscar mensajes",
        noMessagesFound: "Tu bandeja de mensajes está vacía",
        subject: "Assunto:",
        noSubject: "(sin asunto)",
        earlierMessages: "Mensajes anteriores",
        all: "Todos",
        read: "Leídos",
        unread: "No leídos",
        reply: "Responder",
        reply_message:"Escribe tu mensaje de respuesta y haz clic en responder",
        edited_five_minutes: "Editaste hace 5 minutos",
        edited_three_minutes: "Editaste hace 3 minutos",
        message_sent_successfully: "Mensaje enviado con éxito",
        message_sending_failed: "Error al enviar el mensaje",
    },
    chat: {
        startConversation: "Iniciar Conversación",
        send: "Enviar",
    },
    config: {
        title: "Configuraciones de la cuenta",
        shortTitle: "Cuenta",
        notificationsTitle: "Notificaciones",
        linkAccount: "Vincular cuenta",
        password: {
            changePassword: "Cambiar contraseña",
            savePassword: "Guardar contraseña",
            actualPassword: "Contraseña actual",
            informActualPassword: "Ingresa tu contraseña actual",
            newPassword: "Nueva contraseña",
            informNewPassword: "Ingresa una nueva contraseña",
            confirmPassword: "Confirmación de contraseña",
            informConfirmPassword: "Confirma tu nueva contraseña",
        },
        email: {
            changeEmail: "Cambiar tu correo electrónico",
            saveEmail: "Guardar correo electrónico",
            newEmail: "Nuevo correo electrónico",
            informNewEmail: "Ingresa el nuevo correo electrónico",
            confirmeNewEmail: "Confirma el nuevo correo electrónico",
            answer_message: "Escriba su mensaje de respuesta y haga clic en 'responder'",
        },
        notifications: {
            push: {
                title: "Notificaciones push",
                description:
                    "Recibe notificaciones push sobre nuevas vacantes, mensajes y avances en procesos de selección.",
            },
            email: {
                title: "Notificaciones por correo electrónico",
                description:
                    "Recibe actualizaciones por correo electrónico sobre nuevas vacantes, mensajes y avances en procesos de selección.",
            },
            whatsapp: {
                title: "Notificaciones por Whatsapp",
                description:
                    "Recibe actualizaciones por WhatsApp sobre nuevas vacantes, mensajes y avances en procesos de selección.",
            },
        },
        dataPrivacy: {
            title: "Privacidad de datos",
            description1: "También podrás ",
            description2: "ejercer todos los derechos de los titulares ",
            description3:
                "previstos en la Ley General de Protección de Datos – LGPD.",
            seePrivacyPolicy: "Ver política de privacidad",
        },
        cancelAccount: {
            title: "Cancelación de la cuenta",
            btnCancelAccount: "Cancelar Cuenta",
            description1: "La cancelación de la cuenta es un proceso ",
            description2: "irreversible ",
            description3: "que eliminará tus datos del sistema",
            description4: "Esta acción no se puede deshacer.",
            confirmInstruction:
                "Para confirmar la cancelación, escribe la palabra <b>{word}</b> en el campo de abajo.",
            confirmWord: "eliminar",
        },
    },
    candidature_origin_id: {
        label: "¿Cómo encontraste esta oportunidad?",
        placeholder: "",
        description: "Selecciona una opción para concluir tu candidatura.",
    },
    application: {
        status: {
            NOT_DEFINED: "No aplicable",
            STATUS_NOT_ACCEPTED: "No seleccionado en el Proceso de Selección",
            STATUS_EXCLUDED: "Currículum no seleccionado para la oportunidad",
            STATUS_LEAVE: "Se retiró del Proceso de Selección",
            STATUS_CALLED: "Participando en el Proceso de Selección",
            STATUS_ACCEPTED: "Participando en el Proceso de Selección",
            STATUS_WAITING: "Currículum en análisis para la oportunidad",
            STATUS_NOT_CONTACTED: "Currículum en análisis para la oportunidad",
            STATUS_THINKING: "Currículum en análisis para la oportunidad",
            STATUS_NOT_ATTEND: "El candidato no asistió a la entrevista",
            STATUS_NO_PROFILE: "Currículum no seleccionado para la oportunidad",
            STATUS_HIRED: "Aprobado en el Proceso de Selección",
            STATUS_HIRING: "Aprobado en el Proceso de Selección",
            STATUS_DISAPPROVED: "No seleccionado en el Proceso de Selección",
            STATUS_APPROVED: "Participando en el Proceso de Selección",
            STATUS_ACCEPTING: "Candidatura a la oportunidad",
            STATUS_HIRED_CANCELED: "No seleccionado en el Proceso de Selección",
            STATUS_HIRED_REPLACEMENT:
                "No seleccionado en el Proceso de Selección",
        },
        applications: "Candidaturas",
        favorites: "Favoritas",
        title: "Mis Vacantes",
        progress: "Progreso de la vacante",
        jobDetail: "Ver detalles de la vacante",
        applicationStep: "Estás en la fase de candidatura",
        completeSteps: "Completa los pasos a continuación para continuar",
        candidacy_complete:
            "Completa tu currículum para aumentar las posibilidades de ser encontrado.",
        candidacy_confirmed: "¡Candidatura confirmada!",
        candidacy_failure: "¡Candidatura pendiente!",
        start: "Iniciar",
        startInfo:
            "Para iniciar esta etapa necesitas completar la etapa anterior",
        nextStep: "Próxima fase",
        completeMessage:
            "Al completar la trayectoria de candidatura, pasas a la siguiente fase del proceso de selección",
        myApplications: "Mis Vacantes",
        curriculumStep: "Relleno del Currículum",
        quit: "Retirarse",
        seeProgress: "Ver progreso",
        noVacancyEnrolled:
            "No estás participando en ningún proceso de selección",
        searchForVacancies: "Buscar Vacantes",

        confirming_enrollment: "Confirmando Candidatura",
        we_wish_you_very_luck: "¡Te deseamos toda la suerte del mundo!",
        confirmed_enrollment: "Candidatura Confirmada",
        you_can_now_do_the_next_steps:
            "Ahora puedes dar los próximos pasos en el proceso de selección",
        see_next_steps: "Ver Próximos pasos",
        fill_my_curriculum: "Completar mi currículum",
        none_application_yet: "Ninguna candidatura aún",
        keep_searching:
            "Sigue buscando y añadiendo vacantes a tu lista de favoritos.",
        status_application: "Estado: ",
        applied_for_job: "Te postulaste para este puesto el {date}",
        application_completed_on: "Candidatura finalizada el {date}",
        additional_questions: "Existen preguntas adicionales para completar esta candidatura",
        completed_on: "Finalizado el {date}",
        awaiting_completion: "Esperando la finalización del proceso de selección",
        not_approved: "No aprobado en el proceso de selección",
        test_completed_on: "Prueba finalizada el {date}",
        not_applied_for_job: "No te has postulado para este puesto",
        incomplete_fields: "No se han completado todos los campos. Por favor complete los campos a continuación para validar su candidatura:",
        resume_completed: "¡Felicidades! ¡Has completado tu currículum!",
        origin_question: "¿Cómo encontraste esta oportunidad?",
        origin_question_hint: "Selecciona una opción para concluir tu candidatura.",
        origin_required: "Selecciona cómo encontraste esta oportunidad.",
        conclude_application: "Concluir candidatura"
    },
    lgpd: {
        title: "Formulario de Solicitud de Derechos del Titular de Datos Personales",
        subtitle:
            "Orientaciones Generales Disponibilizamos este formulario fundamentado legalmente por el Art.18 de la LGPD, para facilitar el ejercicio de tus derechos previstos en la Ley General de Datos Personales (LGPD). Recordamos que la utilización de este formulario es facultativa, pero se trata de una forma eficiente y segura para el procesamiento de tu solicitud. Después de completar el formulario, será enviado, junto con el(los) comprobante(s) de identidad del solicitante, a la área de protección de datos de la empresa.",
        btn_finish: "Finalizar",
        confirmTitle: "Confirmar solicitud",
        confirmDescription:
            "Al avanzar, tu solicitud será enviada y no se podrá deshacer. Según el derecho que elegiste ejercer, esto puede resultar en la <b>eliminación de tus datos</b>.",
        confirmInstruction:
            "Esta es una acción irreversible. Si deseas continuar, escribe la palabra <b>{word}</b>.",
        confirmWord: "confirmar",
        declaration_of_authenticity: {
            label: "Declaración de Autenticidad de la información proporcionada",
            placeholder: "",
            description:
                "DECLARO, bajo las penas de la ley penal y, sin perjuicio de las sanciones administrativas y civiles, que las copias de los documentos adjuntos a este documento son auténticas y corresponden al documento original.",
        },

        data_holder: {
            label: "¿Es usted el interesado o abogado/representante?",
            placeholder: "",
            description: "",
        },
        sections: {
            personal_data_holder: {
                title: "Calificaciones del titular de datos personales",
                subtitle:
                    "Complete los espacios a continuación con las calificaciones del titular de datos personales.",
            },
            identity_comprovation: {
                title: "Comprobación de la Identidad del Titular de Datos Personales",
                subtitle:
                    "Solicitamos que se anexe a la solicitud el comprobante de identidad del titular de datos personales. Se aceptarán como documentos de identidad civil el RG, el pasaporte, la cédula profesional o cualquier otro documento que contenga la calificación y la foto del solicitante. En caso de que no se anexe el documento de identidad civil a este formulario, Selecty podrá solicitar información adicional al titular de datos personales para poder atender la referida demanda.",
            },
            data_holder_rights: {
                title: "Derechos del Titular de Datos Personales: ¿Qué derechos le gustaría ejercer?",
                subtitle:
                    'Seleccione "Sí" solo para aquellos que desea ejercer en este momento.',
            },
            data_holder_rights_actions: {
                title: "Derechos de los Titulares",
                subtitle: "",
            },
            data_request: {
                title: "Para ayudar a Selecty a responder su solicitud de manera rápida y eficiente, le solicitamos, por favor, que nos proporcione la mayor cantidad de detalles de la información solicitada. Por favor, especifique, detalladamente, su requerimiento aquí:",
                subtitle: "",
            },
            result_request: {
                title: "Comunicación del Resultado de la Solicitud",
                subtitle: "",
            },
            legal_agent_qualifications: {
                title: "Calificaciones del Apoderado o Representante Legal del Titular de Datos Personales (si aplica)",
                subtitle:
                    "Complete los espacios a continuación con las calificaciones del apoderado o representante legal del titular de datos personales (si aplica).",
            },
            comprovation_power_grant: {
                title: "Comprobación de la otorgación o delegación de poderes a terceros (si aplica) sin título",
                subtitle:
                    "Solicitamos que se anexe a la solicitud el comprobante de identidad del apoderado o del representante legal del titular de datos personales, así como el instrumento legal de representación o la prueba de representación parental. Se aceptarán como documentos de identidad civil el RG, el pasaporte, la cédula profesional o cualquier otro documento que contenga la calificación y la foto del apoderado o representante legal del titular de datos personales. En caso de que no se anexe el documento de identidad civil o el instrumento legal de representación a este formulario, Selecty podrá solicitar información adicional al solicitante o a su representante legal del titular de datos personales para poder atender la referida demanda.",
            },
        },
        data_holder_name: {
            label: "Nombre completo del titular de datos personales",
            placeholder: "",
            description: "",
        },
        data_holder_cpf: {
            label: "CPF del titular de datos personales",
            placeholder: "",
            description: "",
        },
        data_holder_phone: {
            label: "Teléfono de Contacto del titular de datos personales",
            placeholder: "",
            description: "",
        },
        data_holder_email: {
            label: "Correo Electrónico de Contacto del titular de datos personales",
            placeholder: "",
            description: "",
        },
        data_holder_category: {
            label: "Categoría del titular de datos personales",
            placeholder: "",
            description: "",
        },
        data_holder_additional_info: {
            label: "Información Adicional",
            placeholder: "",
            description:
                "Cualquier información adicional que pueda ayudarnos a localizar sus datos personales",
        },
        data_holder_document: {
            label: "Adjuntar documento de identidad civil",
            placeholder: "",
            description: "CPF, RG o CNH",
        },
        confirm_treatment_data: {
            label: "¿Desea confirmar la existencia del tratamiento de sus datos personales?",
            placeholder: "",
            description:
                "Permite saber si Selecty realizó cualquier tipo de tratamiento de sus datos personales, aún sin estar seguro si fue atendido o si tuvo algún tipo de relación anterior con nuestra empresa. Art.18, I, LGPD.",
        },

        confirm_access_data: {
            label: "¿Desea tener acceso a sus datos?",
            placeholder: "",
            description:
                "Permite saber sobre el tratamiento de datos personales realizado por Selecty. Este ítem debe ser marcado solo si ya ha sido atendido o ha tenido algún tipo de relación anterior con nuestra empresa. Art.18, II, LGPD.",
        },
        hide_data: {
            label: "¿Desea eliminar, anonimizar o bloquear sus datos?",
            placeholder: "",
            description:
                "Permite la anonimización, bloqueo o eliminación de datos innecesarios, excesivos, tratados en desconformidad con la LGPD o proporcionados mediante consentimiento. Art.18, IV y VI, LGPD. En caso de que algún dato personal no pueda ser eliminado, anonimizado o bloqueado, debido a la necesidad de tratamiento para cumplimiento de obligación legal, ejecución de contrato o cualquier otro motivo, le informaremos.",
        },
        exercise_rights: {
            label: "Si ya sabe de la existencia del tratamiento de sus datos personales por parte de Selecty o si este se confirma, ¿qué derechos le gustaría ejercer?",
            placeholder: "",
            description: "",
        },
        data_request: {
            label: "Si es posible, nos gustaría que nos informara sobre los períodos específicos, horarios, fechas, nombres, tipos de documentos o cualquier otra información relacionada con la solicitud. Recuerde que Selecty podrá ponerse en contacto con el solicitante o su apoderado para solicitar información adicional, en caso de que la solicitud no esté suficientemente clara.",
            placeholder: "",
            description: "",
        },
        result_request: {
            label: "¿Cómo le gustaría ser comunicado sobre el resultado de su solicitud?",
            placeholder: "",
            description: "",
        },
        legal_agent_name: {
            label: "Nombre completo del apoderado o del representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_cpf: {
            label: "CPF del apoderado o del representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_address: {
            label: "Dirección del apoderado o del representante legal",
            placeholder: "",
            description:
                "Calle, Número, Complemento, Código Postal, Ciudad, Estado",
        },
        legal_agent_phone: {
            label: "Teléfono de contacto del apoderado o del representante legal",
            placeholder: "",
            description:
                "Teléfono con código de área en el formato XX XXXXX-XXXX",
        },
        legal_agent_email: {
            label: "Correo electrónico de contacto del apoderado o del representante legal",
            placeholder: "",
            description: "",
        },
        legal_agent_document: {
            label: "Comprobante de identidad del apoderado o del representante legal del titular de datos personales",
            placeholder: "",
            description: "",
        },
        legal_agent_representative_document: {
            label: "Instrumento legal de representación o prueba de representación parental",
            placeholder: "",
            description: "",
        },
    },
    disc: {
        profile: {
            achiever: "Realizador",
            agent: "Representante",
            appraiser: "Evaluador",
            counselor: "Consejero",
            creative: "Creativo",
            developer: "Explorador",
            inspirational: "Inspirador",
            investigator: "Investigador",
            "objective thinker": "Pensador Objetivo",
            overshift: "Expandido",
            perfectionist: "Perfeccionista",
            persuader: "Persuasivo",
            practitioner: "Practicante",
            promoter: "Promotor",
            "result-oriented": "Orientado a Resultados",
            specialist: "Especialista",
            tight: "Estricto",
            undershift: "Comprimido",
        },
        question: {
            I_am: "Soy una persona...",
            More: "Más",
            Less: "Menos",
            Enthuastic: "Entusiasta",
            Daring: "Audaz",
            Diplomatic: "Diplomática",
            Satisfied: "Cooperativa",
            Cautious: "Cautelosa",
            Determined: "Determinada",
            Convicing: "Convincente",
            "Good Natured": "Buena oyente",
            Friendly: "Que habla mucho y hace amigos",
            Accurate: "Que habla de forma precisa y específica",
            Outspoken: "Que habla de forma franca y sin rodeos",
            Calm: "Que habla calmadamente",
            Talkative: "Conversadora",
            Controlled: "Controlada",
            Conventional: "Apoyadora",
            Decisive: "Decidida",
            Adventurous: "Aventurera",
            Insightful: "Perspicaz",
            "Out-going": "Espontánea",
            Moderate: "Moderada",
            Gentle: "Amable",
            Persuasive: "Persuasiva",
            Humble: "Cuidadosa",
            Original: "Osada",
            Expressive: "Expresiva",
            Conscientious: "Consciente",
            Dominant: "Con iniciativa",
            Responsive: "Comprensiva",
            Poised: "Con buen humor",
            Observant: "Analítica",
            Modest: "Mediadora",
            Inpatient: "Impaciente",
            Tactful: "Disciplinada",
            Agreeable: "Solidaria",
            Magnetic: "Encantadora",
            Insistent: "Pionera",
            Brave: "Valiente",
            Inspiring: "Inspiradora",
            Submissive: "Leal",
            Timid: "Tímida",
            Reserved: "Minuciosa",
            Obliging: "Servicial",
            "Strong-willed": "Rápida y objetiva",
            Cheerful: "Creativa",
            Stimulating: "Que le gusta mucha interacción",
            Kind: "Amable",
            Perceptive: "Muy atenta a los detalles",
            Independent: "Independiente",
            Competitive: "Competitiva",
            Considerate: "Reflexiva",
            Joyful: "Popular",
            Private: "Discreta",
            Fussy: "Que piensa objetivamente",
            Obedient: "Que sigue procesos",
            Firm: "Exigente",
            Playful: "Juguetona",
            Attractive: "Agradable",
            Instropective: "Introspectiva",
            Stubborn: "Terquedad",
            Predictable: "Estable",
            Logical: "Que sigue la lógica",
            Bold: "Valiente",
            Loyal: "Leal",
            Charming: "Que intenta agradar a todos",
            Sociable: "Sociable",
            Patient: "Paciente",
            "Self-reliant": "Autosuficiente",
            "Soft spoken": "Que busca precisión",
            Wiling: "Apaciguadora",
            Eager: "Que busca acción y rapidez",
            Thorough: "Meticulosa",
            "High-spirited": "Espirituosa",
            Aggressive: "Que busca objetividad",
            Extroverted: "Extrovertida",
            Amiable: "Amigable",
            Fearful: "Que planea cada paso",
            Confident: "Confiada",
            Sympathetic: "Simpatica",
            Impartial: "Imparcial",
            Assertive: "Que va directo al punto",
            "Well-desciplined": "Muy disciplinada",
            Generous: "Tranquila",
            Animated: "Animada",
            Persistent: "Persistente",
            Impulsive: "Impulsiva",
            Introverted: "Introvertida",
            Forceful: "Incisiva",
            "Easy-going": "Predecible",
            "Good mixer": "Que conecta e integra a las personas",
            Refined: "Observadora y crítica",
            Vigorous: "Enérgica",
            Lenient: "Tolerante",
            Captivating: "Que transmite conocimiento",
            Contented: "Que busca escuchar a todos",
            Demanding: "Que dirige las acciones",
            Compliant: "Que crea procedimientos",
            Argumentative: "Que argumenta para convencer",
            Systematic: "Que analiza la información",
            Cooperative: "Que apoya para resolver",
            "Light-hearted": "Que interactúa y conversa con todos",
            Jovial: "Expansiva",
            Precise: "Detallista",
            Direct: "Que asume riesgos calculados",
            "Even-tempered": "Serena y equilibrada",
            Restless: "Inquieta",
            Neighborly: "Atenta",
            Appealing: "Entusiasta",
            Careful: "Pensativa",
            Respectful: "Con enfoque en el proceso y la planificación",
            Pioneering: "Con enfoque en la acción y el resultado",
            Optimistic: "Con enfoque en las posibilidades y la innovación",
            Helpful: "Con enfoque en el grupo y la cooperación",
        },
        form: {
            welcome: "Dé la bienvenida a su evaluación.",
            instructions: "Haga clic en Continuar y seguir las instrucciones.",
            hello_user: "Hola {0}",
            lets_try_again: "Empezar de nuevo",
            warning_recording_again:
                '"El video previamente grabado para la pregunta no se guardó en el sistema',
            "time-to-response": "por respuesta",
            minutes: "{0} min.",
            seconds: "{0} Sec",
            "testing-your-camera": "Pruebe su cámara",
            "i-can-see-me-and-the-quality-is-good":
                "Me veo y la calidad es buena.",
            "testing-your-audio": "Probar su audio",
            "i-can-hear-me-and-the-quality-is-good":
                "Me escucho y la calidad es buena.",
            congratulations: "Felicitaciones {0}",
            "you-finished": "Ha cumplimentado el cuestionario",
            "wait-return": "Esperar el retorno del selector",
            "to-start": "para comenzar",
            "answer-now": "Responde ahora",
            start: "Para comenzar",
            continue: "Continuar",
            "ok-already-answered": '"Ahí',
            "all-working": "Todo funcionando",
            "have-a-good-interview": "Tenga una buena entrevista",
            question: "Pregunta",
            of: "de",
            disc_behavioural_profile: "perfil de comportamiento DISC",
            "you-are-here-to-discover-your-behavioral-disc-profile":
                "Estás aquí para descubrir tu perfil de comportamiento DiSC",
            "what-is-it-for": "Para que sirve",
            "your-behavioral-profile-will-help-you-understand-how you-work-on-a-team-and-even-in-life-in-general":
                "Tu perfil de comportamiento te ayudará a comprender cómo trabajas en equipo e incluso en la vida en general",
            "lets-begin": "Vamos a empezar",
            "there-will-be-28-quick-questions": "Habrá 28 preguntas rápidas",
            "see-more-instructions-next":
                "Vea más instrucciones a continuación",
            "skip-and-start-the-test": "Salta y comienza la prueba",
            "youve-completed-more-than-half-of-the-test":
                "Ha completado más de la mitad de la prueba",
            "How_was_the_test?": "¿Cómo fue el test?",
            thanks_for_your_feedback: "Agradecemos pelo feedback!",
            we_will_do_our_best_to_improve_your_user_experience:
                "Haremos todo lo posible para mejorar su experiencia de usuario",
            understood: "Entendido",
            start: "Empezar",
            disc_invalid_profile_message:
                "En base a las respuestas proporcionadas, no fue posible ajustar su perfil de comportamiento a los estándares establecidos por la metodología DISC.",
            remake_evaluation:
                "Necesitamos que vuelvas a hacer la evaluación para que se identifique tu perfil y puedas avanzar en este proceso de Reclutamiento y Selección en el que estás postulando.",
            disc_denied_message_intro:
                "Por ahora no es necesario volver a realizar tu DISC",
            disc_denied_message_body:
                "Ha completado el inventario de comportamiento DISC en los últimos 6 meses y su último resultado aún es válido.",
            disc_denied_message_conclusion:
                "Esta medida se adopta para garantizar la coherencia y transparencia de nuestro proceso. ¡Realmente apreciamos su comprensión!",
            execution_date: "Realizado en",
            valid_until: "Actual hasta",
        },
        questions: {
            self_knowledge_activity: "La siguiente actividad puede ayudarte a conocerte aún mejor.",
            next: "Siguiente",
            no_right_or_wrong: "Aquí no hay correcto ni incorrecto.",
            profile_snapshot: "Al finalizar, verás un retrato actual de tu perfil y podrás usar esto para desarrollar tus habilidades conductuales.",
            instructions: "Instrucciones",
            choose_words: "<p>Para cada grupo de palabras, elige la que <b>más te combina</b> y la que <b>menos te combina</b>.</p>",
            back: "Volver",
            return: "Regresar",
            view_result: "Ver resultado",
            test_time_limit: "Límite de tiempo del test:",
            chrome: "Chrome",
            firefox: "Firefox",
            total_test_time: "Tiempo total del test:",
            time_notice: "Una vez iniciado, el tiempo seguirá corriendo incluso si sales de la prueba.",
        },
        results: {
            selection_process: "Proceso Selectivo",
            behavioral_profile_result: "Este resultado presenta un retrato actual de su perfil conductual y no busca definirlo como individuo.",
            unique_individual_statement: "Cada persona es única y nadie cabe en una caja.",
            information_utility_message: "Esperamos que la información mostrada aquí te sea útil. 😊",
            goals: "Objetivos",
            emotions: "Emociones",
            judges_others_based_on: "Juzga a los demás mirando a",
            methods_of_influencing_others: "Métodos de influir en los demás",
            value_to_the_organization: "Valor para la organización",
            uses_excessively: "Usa excesivamente",
            under_pressure: "Bajo presión",
            avoids: "Evita",
            needs_to_develop: "Necesita desarrollar",
        },
        disc_card: {
            click_on_bars_to_read_description: "Haz clic en las barras para leer la descripción de cada factor",
            high_dominance: "Alta Dominancia",
            assertive: "Asertivo",
            competitive: "Competitivo",
            high_self_esteem: "Alta autoestima",
            direct: "Directo",
            objective: "Objetivo",
            positive_behaviors: "Comportamientos Positivos",
            adventurous: "Aventurero",
            takes_initiative: "Toma la iniciativa",
            bold: "Audaz",
            persistent: "Persistente",
            focuses_on_results: "Se centra en los resultados",
            determined: "Determinado",
            limiting_behaviors: "Comportamientos Limitantes",
            takes_too_many_risks: "Arriesga demasiado",
            arrogant: "Arrogante",
            impulsive: "Impulsivo",
            insensitive: "Insensible",
            difficulty_in_delegating: "Dificultad para delegar",
            takes_on_many_responsibilities: "Asume muchas responsabilidades",
            brings_value_to_the_team: "Aporta valor al equipo",
            coordinating: "Coordinando",
            innovating: "Innovando",
            with_proactivity: "Con proactividad",
            with_motivation_in_the_face_of_challenges: "Con motivación ante los desafíos",
            the_ideal_environment_provides: "El ambiente ideal proporciona",
            debates_to_express_viewpoints: "Debates para expresar puntos de vista",
            freedom_to_make_decisions: "Libertad para tomar decisiones",
            challenges_and_opportunities: "Desafíos y oportunidades",
            little_routine: "Poca rutina",
            under_pressure_can_be: "Bajo presión puede ser",
            very_demanding: "Muy exigente",
            aggressive: "Agresivo",
            selfish: "Egoísta",
            low_dominance: "Baja dominancia",
            conservative: "Conservador",
            moderate: "Moderado",
            diplomatic: "Diplomático",
            unpretentious: "Despretensioso",
            careful: "Cuidadoso",
            high_influence: "Alta influencia",
            confident: "Confiado",
            optimistic: "Optimista",
            persuasive: "Persuasivo",
            sociable: "Sociable",
            communicative: "Comunicativo",
            positive_behaviors: "Comportamientos positivos",
            attentive: "Atento",
            charming: "Encantador",
            convincing: "Convincente",
            warm: "Cálido",
            inspiring: "Inspirador",
            good_humored: "Buen humor",
            inattentive_to_details: "Desatento a los detalles",
            loses_focus_easily: "Pierde el foco con facilidad",
            disorganized: "Desorganizado",
            difficulty_completing_tasks: "Dificultad para completar tareas",
            difficulty_managing_time: "Dificultad para gestionar el tiempo",
            speaks_without_thinking: "Habla sin pensar",
            resolving_conflicts_creatively: "Resolviendo conflictos creativamente",
            motivating_others: "Motivando a los demás",
            being_optimistic: "Siendo optimista",
            collaborating: "Colaborando",
            constant_contact_with_people: "Contacto constante con las personas",
            space_to_hear_ideas: "Espacio para escuchar ideas",
            freedom_to_communicate: "Libertad para comunicarse",
            democratic_managers: "Gerentes democráticos",
            very_optimistic: "Muy optimista",
            not_very_realistic: "Poco realista",
            talks_too_much: "Habla demasiado",
            low_influence: "Baja influencia",
            serious: "Serio",
            skeptical: "Escéptico",
            reserved: "Reservado",
            reflective: "Reflexivo",
            rational: "Racional",
            high_stability: "Alta estabilidad",
            good_listener: "Buen oyente",
            self_controlled: "Autocontrolado",
            patient: "Paciente",
            kind: "Amable",
            thoughtful: "Reflexivo",
            friendly: "Amigable",
            peacemaker: "Pacificador",
            calm: "Calmo",
            understanding: "Comprensivo",
            loyal: "Leal",
            avoids_conflicts: "Huye de conflictos",
            lacks_initiative: "Falta de iniciativa",
            dislikes_change: "No le gusta el cambio",
            inflexible: "Poco flexible",
            difficulty_setting_priorities: "Dificultad para establecer prioridades",
            low_ambition: "Poca ambición",
            listening: "Escuchando",
            serving: "Sirviendo",
            conveying_calm: "Transmitiendo calma",
            bringing_consistency: "Trayendo consistencia",
            stability: "Estabilidad",
            few_conflicts: "Pocos conflictos",
            lasting_work_relationships: "Relaciones laborales duraderas",
            predictability: "Previsibilidad",
            indecisive: "Indeciso",
            inflexible: "Inflexible",
            closed: "Cerrado",
            low_stability: "Baja estabilidad",
            active: "Activo",
            restless: "Inquieto",
            impetuous: "Impulsivo",
            energetic: "Enérgico",
            flexible: "Flexible",
            high_conformity: "Alta conformidad",
            self_discipline: "Autodisciplinado",
            precise: "Preciso",
            detail_oriented: "Detallista",
            prudent: "Prevenido",
            perfectionist: "Perfeccionista",
            analytical: "Analítico",
            diplomatic: "Diplomático",
            seeks_achievements: "Busca logros",
            asks_good_questions: "Hace buenas preguntas",
            thinks_objectively: "Piensa objetivamente",
            low_conformity: "Baja conformidad",
            arrogant_when_challenged: "Arrogante cuando se le desafía",
            defensive_to_criticism: "Defensivo a las críticas",
            inflexible: "Inflexible",
            very_critical: "Muy crítico",
            slow_to_act: "Lento para actuar",
            seems_distant_and_cold: "Parece distante y frío",
            solves_problems_using_understanding: "Resuelve problemas utilizando comprensión",
            aware_and_consistent: "Consciente y consistente",
            defines_and_clarifies: "Define y aclara",
            gathers_information_and_tests_it: "Obtiene información y la pone a prueba",
            openness_to_critical_thinking: "Apertura a pensamientos críticos",
            close_relationships_with_small_groups: "Relaciones estrechas con pequeños grupos",
            privacy: "Privacidad",
            freedom_to_question: "Libertad para cuestionar",
            hard_to_please: "Difícil de complacer",
            pessimistic: "Pesimista",
            excessively_meticulous: "Excesivamente meticuloso",
            firm: "Firme",
            independent: "Independiente",

        },
        disc_factors_bar: {
            empathetic: "Empático",

        }
    },
    evaluation: {
        expired: {
            title: "Plazo Expirado",
            description:
                "Desafortunadamente, el plazo para responder la prueba ha vencido",
        },
        form: {
            welcome: "Bienvenido a su evaluación.",
            instructions: "Haga clic en continuar para iniciar su prueba",
            attention: "Atención",
            forward_without_answering: "¿Desea avanzar sin responder?",
            not_possible_return: "No será posible volver a esta pregunta",
            "choose-a-quiet-and-well-lit-place":
                "Elija un lugar tranquilo y bien iluminado",
            "if-possible-use-wifi-or-broadband-connection":
                "Si es posible, use wifi o conexión de banda ancha",
            "so-you-can-focus-on-what-really-matter":
                "Así podrá concentrarse en lo que realmente importa",
            "this-way-you-avoid-problems-with-slowness-during-the-interview":
                "De este modo, evitará problemas de lentitud durante la entrevista",
            "got-it": "Entendido",
            start: "Comenzar",
            "video-interview": {
                "fail-system-requirements":
                    "Desafortunadamente, su navegador no admite este servicio",
                welcome: "Bienvenido a su evaluación.",
                instructions:
                    "Por favor, haga clic en continuar y siga las instrucciones.",
                hello_user: "¡Hola, {0}!",
                lets_try_again: "Intentar de nuevo",
                warning_recording_again:
                    "El video grabado anteriormente para la pregunta no se guardó en el sistema, por favor inténtelo de nuevo",
                "time-to-response": "para respuesta",
                minutes: "{0} min.",
                seconds: "{0} seg",
                "testing-your-camera-and-audio":
                    "Probando su cámara y micrófono",
                "testing-your-camera-and-audio-description":
                    "Grabe un video corto de usted hablando para comprobar su imagen y audio.",
                "testing-your-camera": "Probando su cámara",
                "i-can-see-me-and-the-quality-is-good":
                    "Me veo y la calidad está buena.",
                "testing-your-audio": "Probando su audio",
                "i-can-hear-me-and-the-quality-is-good":
                    "Me escucho y la calidad está buena.",
                congratulations: "Felicitaciones {0}",
                "you-finished": "Ha completado el cuestionario",
                "wait-return": "Espere el regreso del seleccionador",
                "to-start": "para comenzar",
                "answer-now": "Responder ahora",
                start: "Comenzar",
                continue: "Continuar",
                "ok-already-answered": "Listo, ya respondí",
                "all-working": "Todo funcionando",
                "have-a-good-interview": "Tenga una buena entrevista",
                question: "Pregunta",
                of: "de",
            },
            "browser-not-supported": "Navegador no soportado",
            "please-use-one-of-the-browsers-below":
                "Por favor, utilice uno de los navegadores a continuación:",
        },
        evaluation_not_found: "Evaluación no encontrada",
        successfully_reseted: "Reiniciado con éxito",
        evaluation_request_not_found: "Solicitud de evaluación no encontrada",
    },
    "test-alerts": {
        "test-cam": "Probar cámara",
        "test-cam-mic": "Probar cámara y micrófono",
        "test-mic": "Probar micrófono",
    },
    styleguide: {
        spinbutton: {
            field: {
                label: "Campo de Formulario Spinbutton",
                placeholder: "",
                description:
                    "Use los campos a continuación para ajustar el componente",
            },
            step: {
                label: "Paso",
                placeholder: "",
                description: "",
            },
            min: {
                label: "Mín",
                placeholder: "",
                description: "",
            },
            max: {
                label: "Máx",
                placeholder: "",
                description: "",
            },
        },
    },
    faq: {
        title: "Preguntas Frecuentes",
        portal: {
            questions: [ 
                {
                    question: "Descubre cómo recuperar tu inicio de sesión y contraseña si no lo recuerdas o lo has perdido.",
                    answer: "En la página de inicio de sesión, haz clic en 'Olvidé mi contraseña'. Luego, ingresa tu CPF y haz clic en 'Crear nueva contraseña'. Recibirás un correo electrónico registrado en la plataforma con instrucciones para crear una nueva contraseña. Asegúrate de revisar también tu carpeta de spam o correo no deseado si no encuentras el correo en la bandeja de entrada."
                },
                {
                    question: "Descubre cómo recuperar tu inicio de sesión y contraseña incluso sin tener acceso a tu correo electrónico.",
                    answer: "En la página de inicio de sesión, haz clic en 'Olvidé mi contraseña', ingresa tu CPF y haz clic en 'Crear nueva contraseña'. Si no tienes acceso al correo electrónico, haz clic en 'Ya no tengo acceso a este correo electrónico'. Luego, proporciona tu CPF y número de teléfono. Se enviará un código de confirmación a tu teléfono, lo que te permitirá cambiar tu contraseña como de costumbre."
                },
                {
                    question: "¿Qué sucede con mis datos cuando registro mi currículum?",
                    answer: "Cuando te registras y no te postulas a ninguna vacante, tu currículum queda disponible en una base de currículums y puede ser convocado para oportunidades de trabajo. Si realizas una postulación, además de estar disponible en una base de datos, tu perfil será evaluado para la oportunidad deseada."
                },
                {
                    question: "Ya no quiero recibir correos electrónicos de esta empresa. ¿Y ahora qué?",
                    answer: "¡Qué pena! Nuestras comunicaciones tienen como objetivo ayudarte en la recolocación profesional y en la búsqueda de mejores oportunidades. Si no deseas recibirlas, ve al correo recibido y haz clic en la opción 'Si no deseas recibir más mensajes como este, haz clic aquí' o 'Cancelar suscripción'."
                },
                {
                    question: "¿Cómo se pone en contacto conmigo el reclutador?",
                    answer: "La empresa que está llevando a cabo tu proceso de selección tiene la libertad de elegir la mejor manera de contactarte. Si te has postulado y aún no has recibido ningún contacto por correo electrónico, teléfono o redes sociales, espera la respuesta de la empresa, ya que tu perfil aún puede estar en evaluación. Si ya tienes los datos de contacto del reclutador, puedes comunicarte directamente con la empresa."
                },
                {
                    question: "¿Cómo funciona la política de privacidad?",
                    answer: "Al registrarte, aceptas las Políticas de Privacidad de la empresa contratante (si las hay) y de la plataforma Selecty. En la Política de Privacidad, explicamos en detalle cómo recopilamos, utilizamos y protegemos tus datos. Recopilamos esta información para ofrecer la mejor experiencia de servicio posible, personalizar nuestra atención y cumplir con las obligaciones legales, siempre en conformidad con la LGPD (Ley General de Protección de Datos). Para más información, accede al enlace: <a href='https://selecty.com.br/politica-privacidade/' target='_blank'>Haz clic aquí</a>"
                },
                {
                    question: "¿Puedo postularme a diferentes vacantes de la misma empresa?",
                    answer: "¡Sí, es posible! Puedes participar en varios procesos de selección al mismo tiempo, pero la empresa contratante puede establecer las reglas que definen y regulan la participación de candidatos activos en más de un proceso de selección simultáneamente."
                },
                {
                    question: "¿Puedo reutilizar el registro de mi currículum en varias empresas?",
                    answer: "Sí, esto es posible con el inicio de sesión a través de Selecty.Jobs. Registras tu currículum una vez y puedes reutilizarlo en todas las empresas con vacantes disponibles en la plataforma Selecty."
                },
                {
                    question: "¿Cómo solicitar la eliminación de mis datos?",
                    answer: "Después de iniciar sesión en tu cuenta, ve a la pestaña 'Cuenta' y desplázate hasta la pestaña 'Privacidad de datos'. Luego, haz clic en 'ejercer todos los derechos de los titulares' para abrir el Formulario de Solicitud de Derechos del Titular de Datos Personales. Simplemente completa el formulario y haz clic en 'Finalizar' para completar la solicitud."
                },
                {
                    question: "¿Cómo puedo hacer seguimiento a mis procesos de selección?",
                    answer: "Inicia sesión en el portal y accede a la pestaña 'Mis vacantes' en el menú lateral izquierdo. Allí podrás verificar el estado de cada uno de los procesos de selección a los que te has postulado, así como el estado de cada vacante."
                },
                {
                    question: "¿Por qué se cerró mi candidatura?",
                    answer: "Tu candidatura pudo haberse cerrado por diversos motivos, como el cierre o cancelación del proceso de selección, cambios en los criterios de selección de la empresa, entre otros factores. Si tienes dudas, te recomendamos que te pongas en contacto directamente con la empresa para obtener más detalles sobre el cierre."
                },
                {
                    question: "Aún no he recibido una respuesta sobre mi proceso de selección.",
                    answer: "Los plazos de respuesta pueden variar según el proceso de selección y la empresa. Si el tiempo informado ya pasó o has estado esperando por un período prolongado, te recomendamos que te pongas en contacto directamente con la empresa para verificar el estado de tu candidatura. Mantente atento a tu correo electrónico y a tu página de perfil en el portal, donde se pueden enviar actualizaciones sobre el proceso."
                },
                {
                    question: "Ya he completado la etapa más reciente del proceso de selección, pero aún no han liberado la siguiente.",
                    answer: "Si ya completaste la etapa anterior y la siguiente no ha sido liberada, puede ser necesario esperar la revisión del reclutador o del equipo de selección. Para obtener más información sobre el estado de tu proceso, te recomendamos ponerte en contacto directamente con la empresa responsable de la selección. Ellos podrán proporcionarte detalles sobre el progreso y si es necesaria alguna acción por tu parte."
                },
                {
                    question: "Mejores prácticas para el envío de documentos de admisión.",
                    answer: "<p>¡Felicitaciones por tu contratación! Sabemos que este es un momento emocionante y especial.</p><p>Ahora es el momento de enviar tus documentos para completar la admisión, y nos gustaría compartir algunos consejos importantes para garantizar el éxito:</p><p>Los formatos permitidos para el envío de documentos son: JPG, JPEG, PNG, PDF.</p><p>Si no tienes el documento solicitado en mano, se recomienda esperar hasta que esté disponible y evitar enviar otro documento que no corresponda. Por ejemplo, no envíes el recibo del protocolo de la CNH en lugar del documento original solicitado.</p><p>No envíes documentos vencidos. Si se trata de un documento obligatorio (necesario para avanzar en el proceso), ponte en contacto con la empresa responsable del proceso de selección para resolver la situación.</p><p>Las imágenes de los documentos deben estar en alta calidad para evitar devoluciones y retrasos en el proceso.</p><p>Completa todos los campos del formulario de manera correcta y precisa. Si tienes dudas sobre qué llenar en algún campo, realiza una búsqueda o consulta fuentes confiables.</p><p>Envía todos los documentos dentro del plazo estipulado y espera la respuesta de la empresa. Ellos estarán organizando todo para garantizar que tu admisión se realice de acuerdo con la ley, lo que puede llevar algo de tiempo.</p><p>Para preguntas específicas sobre la vacante o la aceptación de otros documentos, comunícate directamente con el reclutador o la empresa contratante.</p>"
                }
        ],
        },
        sj: {
            questions: [
                {
                    question: "Descubre cómo recuperar tu login y contraseña si no los recuerdas o los has perdido.",
                    answer: `En la página de inicio de sesión, haz clic en "Olvidé mi contraseña". Luego, ingresa tu número de CPF y haz clic en "Crear nueva contraseña". Recibirás un correo electrónico registrado en la plataforma con instrucciones para crear una nueva contraseña. Asegúrate de verificar también tu bandeja de spam o correo no deseado si no encuentras el correo en tu bandeja de entrada.`,
                },
                {
                    question: "Descubre cómo recuperar tu login y contraseña sin acceso a tu correo electrónico.",
                    answer: `En la página de inicio de sesión, haz clic en "Olvidé mi contraseña", ingresa tu CPF y haz clic en "Crear nueva contraseña". Si no tienes acceso al correo electrónico, haz clic en "Ya no tengo acceso a este correo electrónico". Luego, proporciona tu CPF y número de teléfono. Un código de confirmación será enviado a tu teléfono, lo que te permitirá cambiar tu contraseña normalmente.`,
                },
                {
                    question: "¿Qué es Selecty.Jobs?",
                    answer: "Para los candidatos, Selecty.Jobs es un marketplace tecnológico que conecta empresas y profesionales. Aquí encontrarás miles de oportunidades laborales y podrás, de manera gratuita, registrar tu currículum y postularte a las vacantes que te interesen.",
                },
                {
                    question: "Cuando registro mi currículum, ¿qué sucede con mis datos?",
                    answer: "Cuando realizas tu registro y no te postulas a ninguna vacante, tu currículum queda disponible para las empresas contratantes, y podrías ser convocado para oportunidades laborales. Si te postulas a una vacante, además de que tu currículum esté disponible para las empresas, tu perfil será evaluado para la oportunidad deseada.",
                },                
                {
                    question: "No quiero recibir más correos de Selecty.Jobs. ¿Qué hago ahora?",
                    answer: `¡Qué lástima! Nuestras comunicaciones están diseñadas para ayudarte en tu recolocación profesional y en la búsqueda de mejores oportunidades. Sin embargo, si ya no deseas recibirlas, ve al correo recibido y haz clic en la opción "Si no deseas recibir más mensajes como este, haz clic aquí" o "Cancelar suscripción".`,
                },
                {
                    question: "¿Debo pagar alguna tarifa si consigo un empleo a través de Selecty.Jobs?",
                    answer: "No. Selecty.Jobs no cobra ningún tipo de tarifa a los candidatos.",
                },
                {
                    question: "¿Cómo me contacta el reclutador?",
                    answer: "La empresa que está llevando a cabo tu proceso de selección tiene la libertad de elegir la mejor forma de contactarte. Si ya te postulaste y no has recibido ningún contacto por correo electrónico, teléfono o redes sociales, espera la respuesta de la empresa, ya que tu perfil aún podría estar en evaluación. Si ya tienes el contacto del reclutador, puedes comunicarte directamente con la empresa.",
                },
                {
                    question: "¿Cómo funciona la política de privacidad?",
                    answer: "En nuestra Política de Privacidad, explicamos detalladamente cómo recopilamos, utilizamos y protegemos tus datos. Recopilamos esta información para ofrecerte la mejor experiencia de servicio posible, personalizar nuestra atención y cumplir con obligaciones legales, siempre en conformidad con la LGPD (Ley General de Protección de Datos). Para más información, <a href='https://selecty.com.br/politica-privacidade/' target='_blank'>haz clic aquí</a>.",
                },
                {
                    question: "¿Puedo postularme a diferentes vacantes en la misma empresa?",
                    answer: "Sí, es posible. Puedes participar en varios procesos de selección al mismo tiempo, pero es la empresa contratante quien establece las reglas que delimitan y regulan la participación de candidatos activos en más de un proceso de selección simultáneamente.",
                },                
                {
                    question: "¿Puedo reutilizar mi currículum en varias empresas?",
                    answer: "Sí. En Selecty.Jobs puedes registrar tu currículum una vez y reutilizarlo en todas las empresas con vacantes disponibles en la plataforma.",
                },
                {
                    question: "¿Cómo solicito la eliminación de mis datos?",
                    answer: `Después de iniciar sesión en tu cuenta, accede a la pestaña "Cuenta" y desplázate hasta la sección "Privacidad de datos", luego haz clic en "ejercer todos los derechos de los titulares" para abrir el Formulario de Solicitud de Derechos del Titular de Datos Personales. Completa el formulario y haz clic en "Finalizar" para completar la solicitud.`,
                },
                {
                    question: "¿Cómo hago un seguimiento de mis procesos de selección?",
                    answer: "Inicia sesión a través del <a href='https://selecty.jobs/login' target='_blank'>enlace</a> y accede a la pestaña 'Mis vacantes' en el menú lateral izquierdo. Allí podrás verificar tu estado en cada uno de los procesos de selección a los que te postulaste, así como el estado de cada vacante.",
                },
                {
                    question: "¿Por qué se ha cerrado mi candidatura?",
                    answer: "Tu candidatura puede haber sido cerrada por diferentes motivos, como el cierre o cancelación del proceso de selección, cambios en los criterios de selección de la empresa, entre otros factores. Si tienes dudas, te recomendamos ponerte en contacto directamente con la empresa para obtener más detalles sobre el cierre.",
                },
                {
                    question: "Aún no he recibido una respuesta sobre mi proceso de selección.",
                    answer: "Los plazos de respuesta pueden variar según el proceso de selección y la empresa. Si ya ha pasado el tiempo informado o llevas esperando mucho tiempo, te recomendamos ponerte en contacto directamente con la empresa para verificar el estado de tu candidatura. Mantente atento a tu correo electrónico y a tu página de perfil en el portal, donde podrían enviarse actualizaciones sobre el proceso.",
                },
                {
                    question: "Ya completé la etapa más reciente del proceso de selección, pero aún no han liberado la siguiente.",
                    answer: "Si ya completaste la etapa anterior y no se ha liberado la siguiente, puede ser necesario esperar el análisis del reclutador o del equipo de selección. Para obtener más información sobre el estado de tu proceso, te recomendamos ponerte en contacto directamente con la empresa responsable de la selección. Ellos podrán proporcionarte detalles sobre el progreso y si se requiere alguna acción por tu parte.",
                },                
                {
                    question: "Buenas prácticas para el envío de documentos de admisión.",
                    answer: "<p>¡Felicitaciones por tu contratación! Sabemos que este es un momento emocionante y especial.</p><p>Ahora es momento de enviar tus documentos para completar la admisión, y queremos compartir algunos consejos importantes para garantizar el éxito del proceso:</p><p><strong>Los formatos permitidos para el envío de documentos son:</strong> JPG, JPEG, PNG, PDF.</p><p>Si no tienes el documento solicitado a mano, te recomendamos esperar hasta que esté disponible y evitar enviar otro documento que no corresponda. Por ejemplo, no envíes el recibo de la CNH en lugar del documento original solicitado.</p><p>No envíes documentos vencidos. Si se trata de un documento obligatorio (necesario para avanzar en el proceso), ponte en contacto con la empresa responsable del proceso de selección para resolver la situación.</p><p>Las imágenes de los documentos deben tener alta calidad para evitar devoluciones y retrasos en el proceso.</p><p>Rellena todos los campos del formulario de manera correcta y precisa. Si tienes dudas sobre qué poner en algún campo, realiza una búsqueda o consulta fuentes confiables.</p><p>Envía todos los documentos dentro del plazo estipulado y espera la respuesta de la empresa. Ellos estarán organizando todo para garantizar que tu admisión se realice conforme a la ley, lo que puede llevar algo de tiempo.</p><p>Para preguntas específicas sobre la vacante o la aceptación de otros documentos, ponte en contacto directamente con el reclutador o la empresa contratante.</p>",
                },
                {
                    question: "¿Cómo tomar una buena imagen para enviar los documentos a la empresa?",
                    answer: "<p>¡Felicitaciones por tu admisión! Ha llegado la hora de enviar tus documentos para completar el proceso.</p><p>Tomar fotos de documentos parece algo muy simple, especialmente cuando tenemos un celular. A continuación, hemos seleccionado algunos consejos que pueden hacer que la experiencia de tu admisión sea más rápida y precisa al enviar imágenes para su validación:</p><ul class='mx-3'><li>Busca un lugar claro e iluminado, ya sea de manera natural o artificial (con lámparas), para capturar las imágenes de tus documentos;</li><li>Aumenta al máximo el brillo de tu celular (el que ilumina la pantalla);</li><li>Alisa o trata de reducir las arrugas o pliegues del documento, para que quede lo más plano posible;</li><li>Coloca el documento sobre una mesa o superficie plana y firme. Si tienes un fondo oscuro, puedes colocarlo detrás del documento, lo que ayudará a mejorar la calidad de la imagen.</li><li>Es importante encuadrar todo el documento en la pantalla, sin dejar fuera ningún borde;</li><li>Presta atención a las sombras que puedan formarse al capturar la imagen;</li><li>Toma la foto exactamente desde arriba, en el mismo ángulo de la superficie (el documento debe formar un rectángulo perfecto, sin permitir que la parte superior sea más pequeña que la inferior o que haya diferencias en los lados);</li><li>Después de capturar la imagen con la aplicación de fotos, ajusta los bordes recortando los lados que no pertenezcan al documento (que son del fondo detrás de él);</li></ul><p>Confirma la visibilidad respondiendo “sí” a estas preguntas. Si alguna de ellas es respondida con “no”, por favor, repite el proceso:</p><ol class='mx-3'><li>¿El documento aparece en su totalidad? ¿Se ven todos los lados sin cortes?</li><li>¿El enfoque es adecuado? ¿Puedo leer todo sin que las letras y números estén borrosos?</li><li>¿Es posible ver con claridad toda la información del documento? ¿Está bien en cuanto a la luminosidad (ni demasiado claro ni demasiado oscuro)?</li></ol><p>También puedes utilizar aplicaciones para escanear la imagen con tu celular o una impresora que digitalice la imagen con calidad. Es importante recordar que el sistema solo acepta el envío de documentos con las extensiones jpg, jpeg, png, pdf</p><p>¡Buena sesión de fotos!</p>",
                },
                {
                    question: "¿Cómo funciona la admisión online?",
                    answer: "La admisión online facilita y acelera el proceso de contratación, permitiendo que todo el trámite se realice de manera digital. El candidato registra su información personal y profesional directamente en la plataforma y envía los documentos necesarios para la empresa de forma rápida y segura. La empresa puede solicitar también etapas presenciales, como el examen médico admisional, por ejemplo.",
                },                
                {
                    question: "¿Cuáles son los documentos solicitados en el proceso de admisión?",
                    answer: "<p>Los documentos exigidos para la admisión varían según la legislación laboral y las políticas internas de cada empresa, pero algunos documentos suelen solicitarse en casi todos los procesos de admisión. En Brasil, por ejemplo, los documentos más comunes incluyen:</p><ul><li><strong>Carteira de Trabalho e Previdência Social (CTPS)</strong><br>Documento obligatorio para formalizar el vínculo laboral.</li><li><strong>Documento de Identidad (RG)</strong><br>Se utiliza para comprobar la identidad del empleado.</li><li><strong>Cadastro de Pessoa Física (CPF)</strong><br>Documento que identifica al trabajador ante la Receita Federal.</li><li><strong>Título de Eleitor</strong><br>Se puede solicitar el comprobante de quita electoral.</li><li><strong>Comprobante de Residencia</strong><br>Para verificar la dirección actual del empleado.</li><li><strong>Certificado de Reservista (para hombres)</strong><br>Prueba de cumplimiento del servicio militar obligatorio, cuando sea aplicable.</li><li><strong>Carteira Nacional de Habilitação (CNH)</strong><br>Si el puesto requiere licencia de conducir, como en el caso de conductores.</li><li><strong>Certificado de Nacimiento o Matrimonio</strong><br>Para registrar el estado civil.</li><li><strong>Comprobante de Escolaridad</strong><br>Certificados o diplomas que demuestren el nivel de educación requerido para el puesto.</li><li><strong>PIS/PASEP</strong><br>Si el trabajador ya está registrado, debe proporcionar el número.</li><li><strong>Atestado Médico Admisional</strong><br>Documento emitido después de los exámenes médicos de admisión para comprobar la aptitud del empleado para el trabajo.</li><li><strong>Foto 3x4</strong><br>Algunas empresas aún solicitan una foto para el archivo personal.</li><li><strong>Comprobante de Situación Catastral en el CPF</strong><br>Para confirmar que el CPF está regular ante la Receita Federal.</li><li><strong>Declaración de Dependientes para el Impuesto sobre la Renta</strong><br>Documento utilizado para fines de deducción del IR y cálculo de beneficios.</li><li><strong>Cartilla de Vacunación (algunos sectores)</strong><br>Algunas empresas exigen comprobantes de vacunas, especialmente en sectores de salud.</li></ul><p>Estos son los documentos básicos, pero algunas empresas pueden solicitar documentos adicionales según la función o el sector en el que se desempeñen.</p>",
                },
                {
                    question: "Correos electrónicos de la plataforma dirigidos a la carpeta de Spam o Correo no deseado",
                    answer: "<p>Al participar en un proceso de selección a través de Selecty.Jobs, normalmente el principal canal de comunicación entre la empresa contratante y tú será el correo electrónico. Por lo tanto, es importante que revises tu correo regularmente, incluyendo la carpeta de Spam.</p><p>Algunos proveedores de correo electrónico pueden marcar los mensajes enviados desde la plataforma como sospechosos, enviándolos a las carpetas de Spam o Correo no deseado, lo que puede hacer que te pierdas alguna comunicación importante sobre el avance del proceso de selección.</p><p>Además de revisar las carpetas de Spam, para evitar que esto suceda, es necesario marcar nuestros correos electrónicos como confiables o definir el dominio @selecty.com.br como confiable, si tu proveedor ofrece esta opción. Consulta cómo hacerlo:</p><p class='mb-0'>Si tu correo es del proveedor Google:</p><a href='https://support.google.com/mail/answer/1366858?hl=pt-PT&authuser=1&expand=5' target='_blank'>Marcar o desmarcar como spam en Gmail;</a><p class='mb-0 mt-3'>Si tu proveedor es Microsoft Outlook (Hotmail y Outlook):</p><a href='https://support.microsoft.com/pt-br/topic/filtrar-lixo-eletr%C3%B4nico-e-spam-no-outlook-db786e79-54e2-40cc-904f-d89d57b7f41d' target='_blank'>Filtrar correo no deseado y spam en Outlook en la web</a><p class='mb-0 mt-3'>Para los dominios BOL y UOL:</p><a href='https://email.bol.uol.com.br/paginas-de-ajuda/sobre/configuracoes/antispam/como-funciona-o-antispam-do-seu-bol-mail.jhtm' target='_blank'>Cómo funciona el AntiSpam de tu BOL Mail</a><br><a href='https://email.uol.com.br/paginas-de-ajuda/sobre/configuracoes/antispam/configuracoes-antispam.jhtm' target='_blank'>Cómo funciona el AntiSpam UOL</a><p class='mb-0 mt-3'>Dominio Icloud:</p><a href='https://support.apple.com/pt-br/102376' target='_blank'>Marcar correos electrónicos legítimos como no deseados</a><p class='mb-0 mt-3'>Dominio Yahoo:</p><a href='https://br.ajuda.yahoo.com/kb/SLN28056.html?guccounter=2&guce_referrer=aHR0cHM6Ly9zdXBwb3J0LWNhbmRpZGF0ZXMuZ3VweS5pby8&guce_referrer_sig=AQAAAMRxkZHhZ4rJ_K3evwpoib9jAY5V1IAtFuLCfcj0BHdyL6iYyweDFc0WfvinTUyEcVYlHiahKX3z-Ka0E78bR6-thiKnX20UJ6DWYLVmfr-LKmHGdkG4T4m5NK0AUWBoAH2ru8XpLcbrR_OqNVzFvpaEwdVaMEm56S0nL3hl80b8' target='_blank'>Cómo gestionar spam y listas de distribución en Yahoo Mail</a><p class='mt-3'>Si tu correo tiene otro dominio que no ha sido listado anteriormente, te recomendamos que accedas al Centro de Ayuda del mismo para entender cómo marcar los correos electrónicos como confiables o eliminarlos de la carpeta de Spam.</p>",
                },
                {
                    question: "Términos y Condiciones de uso",
                    answer: "<a href='https://selecty.com.br/termos-de-uso/' target='_blank'>Haga clic aquí</a> para saber más.",
                },
            ],
        },
    },
    terms_of_use: {
        companies: {
            title: "Términos de Uso para Empresas",
            subtitle: "Servicio: JobPost - Publicación Gratuita de Vacantes",
            content: `
                <h5>1. Registro de Empresas, Perfil Público y Uso de Cuenta</h5>
                <p>1.1. El registro de la empresa en el portal {portal_url} ("Portal") implica la obligación de proporcionar información de la empresa y datos personales de los representantes de la empresa, incluyendo nombre, correo electrónico y número de teléfono. Después de la validación del registro, la empresa podrá acceder a los servicios proporcionados por Selecty.</p>
                <p>1.2. El servicio JobPost está destinado exclusivamente a la divulgación de vacantes de empleo de la propia empresa registrada, actuando como "empleador directo". No se permite el uso del servicio para la publicación de vacantes de terceros o para cualquier tipo de trabajo que no esté destinado a cubrir el personal de la propia empresa.</p>
                <p>1.3. Selecty se reserva el derecho de rechazar el registro de empresas a su exclusivo criterio, incluyendo pero no limitándose a razones comerciales, violaciones previas de los Términos de Uso, o denuncias de actividades consideradas inapropiadas.</p>
                <p>1.4. Solo empresas debidamente constituidas y en situación regular pueden realizar el registro, y cada sucursal debe mantener su propio registro de acceso. Está expresamente prohibido revender, compartir el acceso a la cuenta o utilizar el Portal para fines distintos de la publicación de ofertas de empleo.</p>
                <p>1.5. La empresa registrada tendrá un perfil público para la divulgación de información como logotipos y beneficios ofrecidos a los empleados. El registro y la publicación de vacantes son gratuitos para la mayoría de las empresas, sin embargo, algunas pueden estar obligadas a adquirir planes de servicios pagos para utilizar ciertos recursos.</p>
                <p>1.6. Selecty puede proporcionar información sobre la empresa registrada a las autoridades competentes si es requerido legalmente.</p>
                <h5>2. Reglas de Publicación de Vacantes</h5>
                <p>2.1. Las vacantes publicadas deben cumplir con la legislación vigente y no pueden contener términos inapropiados, ofertas inadecuadas, incitación al odio, discriminación o cualquier contenido ilícito. La responsabilidad por el contenido de las vacantes es íntegramente de la empresa que las publica, pudiendo la misma desactivar sus ofertas en cualquier momento.</p>
                <p>2.2. Selecty se reserva el derecho de bloquear, suspender o cancelar el registro de empresas que utilicen el Portal para la publicación de vacantes de manera abusiva o en desacuerdo con estos Términos de Uso.</p>
                <h5>3. Gratuito y Tarifas</h5>
                <p>3.1. El servicio JobPost se proporciona de forma gratuita, incluyendo las siguientes funcionalidades: (a) publicación de la vacante en el Portal {portal_url} y (b) recepción de los currículums de los profesionales que se postulen a la vacante.</p>
                <p>3.2. Si la empresa desea acceder a recursos adicionales o funcionalidades premium en la plataforma, podrá optar por contratar planes pagados, según lo descrito en los paquetes ofrecidos por Selecty.</p>
                <h5>4. Duración de las Vacantes y Renovación</h5>
                <p>4.1. Las vacantes publicadas tendrán una duración máxima de 90 (noventa) días. Después de este período, Selecty podrá, a su discreción, desactivar automáticamente la vacante, quedando a la empresa el derecho de renovar la publicación si la posición aún no ha sido cubierta.</p>
                <h5>5. Contenido de las Vacantes y Responsabilidad</h5>
                <p>5.1. Selecty podrá, a su exclusivo criterio, auditar y revisar el contenido de las vacantes publicadas periódicamente, sin embargo, no asume ninguna responsabilidad por el contenido publicado por la empresa. Las vacantes consideradas duplicadas, irreales o que infrinjan la legislación vigente serán eliminadas del Portal.</p>
                <h5>6. Vacantes para Menores Aprendices</h5>
                <p>6.1. La empresa es responsable de observar y cumplir con todas las normas y directrices específicas para la contratación de menores aprendices, incluyendo los requisitos de edad y la jornada laboral.</p>
                <h5>7. Recepción de Postulaciones</h5>
                <p>7.1. La publicación de vacantes en el Portal {portal_url} permitirá que los candidatos se inscriban y pongan sus currículums a disposición de la empresa. A partir de ese momento, la empresa asume la plena responsabilidad de la comunicación, relación y negociaciones con los candidatos profesionales.</p>
                <p>7.2. Selecty no se responsabiliza por la información proporcionada por los profesionales, ni por la compatibilidad de los currículums con la vacante ofrecida, ni por el volumen de postulaciones recibidas.</p>
                <h5>8. Protección de Datos</h5>
                <p>8.1. Las empresas se comprometen a tratar los datos de los candidatos con confidencialidad, utilizando dicha información exclusivamente para los procesos de selección relacionados con la vacante publicada. La creación de bases de datos privadas o el uso de esta información para otros fines está expresamente prohibida.</p>
                <p>8.2. La empresa declara expresamente que cumple con las directrices y principios establecidos por la Ley General de Protección de Datos (Ley nº 13.709/2018 - LGPD) y que cuenta con una estructura adecuada para atender las solicitudes de los titulares de datos personales, así como para rendir cuentas sobre los tratamientos realizados.</p>
                <h5>9. Denuncias y Sanciones</h5>
                <p>9.1. En caso de irregularidades o violación de estos Términos de Uso, Selecty podrá suspender o cancelar el registro de la empresa, sin derecho a reembolso o indemnización.</p>
                <h5>10. Rescisión y Cancelación de los Servicios</h5>
                <p>10.1. Selecty se reserva el derecho de cancelar la prestación de los servicios en cualquier momento, sin necesidad de aviso previo, en caso de violación de estos Términos de Uso o de cualquier disposición legal.</p>
            `,
        },
        candidates: {
            sj: {
                title: "TÉRMINOS Y CONDICIONES GENERALES DE USO DEL SERVICIO",
                content: `
                    <p>Los siguientes términos y condiciones se aplican a los beneficios y servicios prestados por la empresa SELECTY TECNOLOGIA PARA RH LTDA, persona jurídica de derecho privado, con sede en Rua Professor Pedro Viriato Parigot de Souza, n° 3.901 – sala 38 – Cidade Industrial, en el Municipio de Curitiba, Estado de Paraná, CEP 81.280-330, registrada en el CNPJ/MF con el nº 09.236.362/0001-50, en adelante SELECTY, para el procedimiento de registro electrónico, que puede realizarse realizado por cualquier persona física o jurídica, en adelante USUARIO, incluido el registro y mantenimiento de su CV en este software.</p>
                    <h5>Primera cláusula: CONSIDERACIONES GENERALES</h5>
                    <p>Al aceptar los términos, usted acepta estar sujeto a los siguientes términos y condiciones (TÉRMINOS Y CONDICIONES GENERALES DE USO DEL SERVICIO). Si contrata para representar a una persona jurídica, declara que tiene los poderes de representación legal, así como poderes para representar a todos los usuarios que utilicen los servicios de acceso a través de su cuenta con estos términos y condiciones, cualquier persona natural, persona jurídica ( sus casas matrices y sucursales), así como sus usuarios autorizados. Si no tiene dichas facultades/poderes, o si no está de acuerdo con los términos y condiciones, deberá marcar la casilla “He leído y no acepto los TÉRMINOS Y CONDICIONES GENERALES DE USO DEL SERVICIO”.</p >
                    <p>Al aceptar este instrumento, llenando el formulario “HE LEÍDO y ACEPTO los TÉRMINOS Y CONDICIONES GENERALES DE USO DEL SERVICIO” luego de completar el proceso de registro, el consentimiento a este contrato es AUTOMÁTICO, el USUARIO expresa su pleno consentimiento para seguir adelante.</p>
                    <p>El USUARIO, entendido como la persona mayor de 18 (dieciocho) años o menor de edad debidamente representado por su(s) tutor(es) que accede al sistema SELECTY con el fin de registrar y mantener sus datos curriculares en el sistema, declara que acepta los términos y condiciones contenidos en el presente término, adhiriendo al proceso de registro proporcionado por SELECTY.</p>
                    <h5>Cláusula segunda: DESCRIPCIÓN DE PRODUCTOS Y SERVICIOS – OBJETO DEL CONTRATO</h5>
                    <p>El objeto del presente acuerdo es la utilización por parte del USUARIO de los servicios prestados por SELECTY, consistente en:</p>
                    <p>Registro, alojamiento, exhibición y difusión del CV registrado por el USUARIO en el SOFTWARE, el cual será puesto a disposición de empresas que estén interesadas en destinar recursos humanos a un determinado área/segmento de mercado; envío y recepción de mensajes electrónicos (correo electrónico); indicación de nuevos usuarios y el aprovechamiento de los beneficios resultantes. La función social del SOFTWARE es ayudar al USUARIO a perseguir sus objetivos en el mercado laboral.</p>
                    <h5>Cláusula tercera: OBLIGACIONES DEL USUARIO / CONDICIONES DE USO</h5>
                    <p>El USUARIO se compromete a no utilizar los servicios prestados por SELECTY para: Fines ilegales o para transmitir u obtener material que no cumpla con la legislación brasileña; Transmitir/difundir material que sea ilegal, difamatorio, que viole la privacidad de terceros, o que sea abusivo, amenazante, obsceno, dañino, calumnioso, calumnioso; Enviar/divulgar cualquier tipo de virus o archivos que contengan cualquier tipo de virus o que puedan causar daño al destinatario o a terceros; Obtener o intentar obtener acceso no autorizado a otros sistemas informáticos o redes conectadas al Servicio; Crear una identidad falsa, incluyendo el uso, sin autorización, del CPF y otros documentos de terceros; El USUARIO se compromete además a no introducir nunca su nombre, dirección, teléfono, fax, correo electrónico o cualquier otro dato de contacto fuera de los campos especificados al efecto. En caso de que SELECTY determine que el USUARIO ha incumplido con cualquiera de las obligaciones establecidas en este término de uso, SELECTY tiene el derecho de SUSPENDER o ELIMINAR la divulgación y los datos del USUARIO, o incluso resolver inmediatamente este contrato, independientemente de cualquier premonitoria. acto. El USUARIO es el único responsable del contenido de las transmisiones realizadas a través del servicio, utilizando su contraseña o cuenta. El USUARIO también es responsable del equipo necesario para conectarse a Internet (computadora, línea telefónica, módem y programas informáticos para el acceso) y los costos de conexión.</p>
                    <p>Se prohíbe al USUARIO modificar, copiar, distribuir, transmitir, exhibir, realizar, reproducir, publicar, poner a disposición, licenciar o crear perfiles o currículums derivados de información de terceros, no propios, bajo pena de violación de este término. e infracción legal. El USUARIO tiene prohibido crear perfiles falsos (FAKES).</p>
                    <p>A menos que haya sido autorizado expresamente por escrito por SELECTY para hacerlo, el USUARIO acepta que, al utilizar el Sistema/SOFTWARE, no utilizará ninguna marca comercial, marca de servicio, marca registrada, logotipo de ninguna empresa u organización, como así como que no registrará ni insertará en el Sistema/SOFTWARE ninguna información, texto o imagen confidencial que sea propiedad de terceros, siendo la exclusiva responsable y eximiendo a SELECTY de cualquier responsabilidad respecto de la violación de la propiedad intelectual (VER POLÍTICA DE PRIVACIDAD) de terceros. terceros que el USUARIO pueda cometer mediante dichos actos. En este caso, SELECTY podrá, independientemente de notificación formal previa, excluir cualquier tipo de material, archivado por el USUARIO, que viole la propiedad intelectual de terceros, incluso pudiendo excluir definitivamente al USUARIO del sistema.</p>
                    <p>Con base en el principio de autonomía de voluntad, cualquiera de las partes del presente instrumento, en cualquier momento, podrá dar por terminado el presente instrumento sin motivo alguno, sin que este acto genere derecho a ningún tipo de compensación a la otra parte, de cualquier naturaleza. , en cuyo caso deberá enviar un correo electrónico o cualquier otra forma de comunicación a la otra parte, con 10 (diez) días de antelación, informándole de la terminación, que se producirá automáticamente al finalizar este plazo. La resolución no supondrá la renuncia a cualesquiera pérdidas o daños que cualquiera de las partes haya podido causar a la otra durante la ejecución de este contrato.</p>
                    <p>El USUARIO será única, directa y exclusiva responsable de todos los daños, infracciones, incumplimientos legales y actos de cualquier naturaleza que puedan causarse a terceros u otras personas por la utilización del sistema amparado por este instrumento. En caso de que SELECTY sea demandada judicialmente por daños causados ​​por el USUARIO, se le permitirá alegar su ilegitimidad pasiva, señalarlo como autor, denunciarlo a la demanda, etc., y realizar todos los actos necesarios para ejercer su derecho. de defensa y posible devolución, sirviendo este instrumento como título ejecutivo extrajudicial de todas y cada una de las sumas eventualmente gastadas por SELECTY para cubrir indemnizaciones, gastos judiciales, etc., debiendo ser actualizadas de conformidad con la ley, así como aplicarse sanción. cláusula del 10% (diez por ciento) del total de su deuda.</p>
                    <p>El USUARIO reconoce que el contenido insertado en la base de datos de SELECTY, incluyendo, entre otros, texto, música, video, sonidos, base de datos y otros materiales contenidos en otros anuncios disponibles en el servicio, así como la información divulgada al El USUARIO a través del servicio o de los anunciantes, puede estar protegido por derechos de autor, marcas comerciales, patentes u otros derechos de propiedad intelectual. (VER POLÍTICA DE PRIVACIDAD) El USUARIO es consciente de que podrá utilizar la información y materiales sólo si lo autoriza SELECTY o las personas físicas y jurídicas anunciantes. El USUARIO no podrá copiar, reproducir, transmitir, distribuir o recrear de forma derivada el contenido ya proporcionado, sin la autorización expresa del titular del derecho de propiedad.</p>
                    <p>La violación de cualquiera de los términos siguientes resultará en la cancelación de su cuenta. El USUARIO es consciente de que SELECTY no se hace responsable del contenido publicado en el SOFTWARE y que usted puede estar expuesto a dichos materiales. El USUARIO acepta utilizar el SOFTWARE bajo su propia responsabilidad.</p>
                    <h5>Cláusula cuarta: RESPONSABILIDADES DE LA SELECCIÓN</h5>
                    <p>Para todos los efectos legales, SELECTY aclara e informa al USUARIO que todos sus datos curriculares e información personal, ingresados ​​al acceder al sitio web de SELECTY, serán consultados en cualquier momento por otras empresas que utilicen los sistemas informáticos puestos a disposición por SELECTY TECNOLOGIA PARA. RH LTDA, las cuales sirven de base para la investigación y selección de candidatos y procesos de selección. En este sentido, los datos serán archivados en los sistemas dispuestos por ésta, pudiendo comunicarlos a otras empresas. SELECTY informa que revelará los datos personales del USUARIO al Estado y Autoridades Públicas sin el permiso previo del USUARIO sólo cuando así lo requiera legalmente.</p>
                    <p>SELECTY podrá, en cualquier momento, rectificar los términos del presente contrato en caso de necesidad de adaptación, actualización o cambio, comprometiéndose a poner una nueva copia a disposición de sus usuarios, informando al SOFTWARE de la existencia de la nueva versión. del contrato y solicitando el consentimiento expreso.</p>
                    <p>SELECTY buscará mantener el sistema o SOFTWARE accesible de forma ininterrumpida todos los días (24 horas x 7 días a la semana) libre de errores del sistema. El USUARIO es consciente de que SELECTY no se hace responsable de la imposibilidad de enviar datos al sistema debido a imposibilidad de acceso o fallo de comunicación del sistema SOFTWARE o por otros motivos fuera de su control.</p>
                    <p>SELECTY no es responsable de la inserción o reubicación del USUARIO en el mercado laboral, ni de las consecuencias derivadas de la posición del USUARIO en el mercado laboral ocurrida a través del SOFTWARE.</p>
                    <p>SELECTY no tiene ninguna responsabilidad por posibles daños materiales, morales o de otra índole a la vida profesional del USUARIO causados ​​por la visualización de su currículum en el SOFTWARE por parte de terceros en general.</p>
                    <p>SELECTY no es responsable de los medios, publicidad, producto, contenido ofrecido en el SOFTWARE a través de enlaces, cookies con publicidad. Tampoco se responsabiliza de los daños y perjuicios que pueda sufrir el USUARIO por el acceso al CV por parte de terceros. Asimismo, SELECTY no es responsable del contenido o veracidad de los anuncios de vacantes publicados en el SOFTWARE. Por lo tanto, cualquier negociación entre el USUARIO y el tercero anunciante no será responsabilidad de SELECTY, comprometiendo únicamente al tercero anunciante y al respectivo USUARIO que contrató al tercero anunciante.</p>
                    <p>SELECTY no será responsable de posibles daños derivados del acceso ilícito de terceros o piratas informáticos al SOFTWARE. SELECTY no se hace responsable de los daños que puedan producirse en los equipos del USUARIO o de terceros que accedan al SOFTWARE, causados ​​por un mal uso del SOFTWARE y demás software, posible hardware o el uso de internet.</p>
                    <p>SELECTY ha implementado constantemente medidas de seguridad diseñadas para proteger la información personal que el USUARIO comparte, incluyendo medidas físicas, electrónicas y procesales. SELECTY también supervisa periódicamente sus sistemas en busca de posibles vulnerabilidades y ataques, y busca periódicamente nuevas formas y servicios de terceros para mejorar la seguridad y privacidad del USUARIO.</p>
                    <p>SELECTY tiene derecho a consultar la información ingresada por el USUARIO con el fin de identificar y resolver problemas técnicos, brindar soporte al USUARIO, obedecer órdenes legales y todo lo necesario para asegurar que los servicios se presten dentro de los preceptos éticos y legales vigentes y aplicable a la especie.</p>
                    <p>Independientemente de las medidas y esfuerzos realizados por SELECTY, la protección absoluta de la información personal del USUARIO, o cualquier otro material que el USUARIO cargue, publique o comparta de otra manera con SELECTY, no es posible y no está garantizada. Por este motivo, SELECTY alienta al USUARIO a colocar contraseñas seguras en su cuenta y a evitar proporcionar a SELECTY o a cualquier otra persona información confidencial que el USUARIO crea que podría causar un daño considerable e irreparable si se revela.</p>
                    <p>En los casos en que terceros no autorizados invadan el sistema de forma ilegal, SELECTY no se hace responsable de los daños causados ​​por los mismos.</p>
                    <h5>Cláusula quinta: REGISTRO Y EDICIÓN DE CV</h5>
                    <p>El registro del USUARIO para utilizar los servicios objeto de este contrato se realizará mediante la creación de una identificación y contraseña únicas y la cumplimentación correcta de datos personales y profesionales, para la construcción automática de su CV profesional.</p>
                    <p>El USUARIO se obliga a proporcionar información veraz, actualizada y completa, observando las solicitudes en las páginas de registro. Entre estos datos, se le solicitará su propio CPF/MF (REGISTRO DE PERSONAS – MINISTERIO DE HACIENDA) o, si no lo tiene, el CPF del tutor legal.</p>
                    <p>La inserción, corrección, así como la veracidad de todos los datos e información aportados por el USUARIO en el registro de su CV, o en cualquier otro servicio, será responsabilidad única y exclusiva del USUARIO.</p>
                    <p>El USUARIO se obliga a mantener la confidencialidad de su contraseña, debiendo tomar todas las precauciones necesarias para evitar un uso incorrecto por parte de terceros no autorizados, siendo además responsable de cualquier mal uso de la misma. SELECTY no se hace responsable del acceso de personas no autorizadas a la contraseña del USUARIO.</p>
                    <p>El USUARIO tiene prohibido crear y mantener más de un registro en el software.</p>
                    <p>El USUARIO, después de registrarse, podrá, en cualquier momento, editar cualquier dato contenido en su CV, a excepción de su número CPF/MF, simplemente INICIANDO SESIÓN en el SOFTWARE.</p>
                    <p>EL USUARIO, al haber INICIADO SESIÓN en el SOFTWARE, podrá insertar datos adicionales a su CV (como experiencia profesional, idiomas, cursos, calificaciones, números de teléfono), optar por mantener confidencial su CV profesional, modificar y actualizar cualquier y toda la información contenida en tu base de datos, brindar acceso y visualización de tu CV a otras empresas, elegir recibir correos electrónicos o mensajes en tu celular.</p>
                    <p>El USUARIO está obligado a actualizar su información en el sistema dentro del plazo legal. SELECTY tiene permiso y derecho a eliminar los registros de los USUARIOS que no actualicen sus datos dentro de este plazo, independientemente de cualquier aviso premonitorio.</p>
                    <p>Todas las obligaciones relacionadas con el Registro se aplican también a la edición del CV por parte del USUARIO.</p>
                    <p>El USUARIO es consciente de que a través de la clave de configuración puesta a disposición en el SOFTWARE SELECTY, el USUARIO podrá desactivar su CV, dejándolo así no disponible para el acceso de búsqueda por parte de las empresas interesadas que utilicen el sistema SELECTY.</p>
                    <h5>Cláusula sexta: VALOR DE LOS SERVICIOS</h5>
                    <p>Por el registro y publicación de su CV, el USUARIO no abonará ningún importe a SELECTY, ya que el registro es totalmente gratuito. SELECTY no se hace responsable de los pagos realizados por el USUARIO a terceros, pues informa desde ahora que no cobra importe alguno al USUARIO por el uso del SOFTWARE.</p>
                    <h5>Cláusula séptima: DURACIÓN DEL CONTRATO</h5>
                    <p>Este contrato tiene duración indefinida y permanece vigente mientras el USUARIO mantenga su CV registrado en el SOFTWARE, debidamente actualizado.</p>
                    <p>El USUARIO podrá, en cualquier momento, rescindir este contrato, simplemente contactando con SELECTY SOFTWARE e informando al CPF solicitando la eliminación de su CV en el SOFTWARE, siendo consciente de que la cancelación de su registro ya no será publicada.< /p>
                    <h5>Cláusula octava: JURISDICCIÓN COMPETENTE</h5>
                    <p>Los términos de servicios y la relación entre las partes se regirán e interpretarán de acuerdo con las Leyes de la República Federativa del Brasil. El USUARIO y SELECTY acuerdan expresamente someterse a la jurisdicción única y exclusiva de los tribunales brasileños, cualquier disputa o litigio relacionado con este término será sometido a trámite y sentencia ante el tribunal del distrito de Curitiba/PR, con renuncia a cualquier otro, por más más privilegiado que tú.</p>
                    <h5>Cláusula novena: DISPOSICIONES GENERALES</h5>
                    <p>Todas y cada una de las comunicaciones entre las partes deberán realizarse mediante correo electrónico, correspondencia o cualquier medio escrito que pueda acreditar la recepción por parte de la otra parte.</p>
                    <p>Nuevamente, el USUARIO autoriza expresamente a SELECTY a publicar su CV a través de otros sitios web, utilizando sistemas informáticos puestos a disposición por SELECTY TECNOLOGIA PARA RH LTDA, en cuyo caso se aplican todos los términos de este contrato, los cuales serán transferidos automáticamente a otras empresas que hacer que la información esté disponible.</p>
                    <p>Por lo tanto, al aceptar los términos, usted acepta estar sujeto a los siguientes términos y condiciones (TÉRMINOS Y CONDICIONES GENERALES DE USO DEL SERVICIO) como se mencionó anteriormente.</p>
                `
            }
        }
    },
    privacy_policy: {
        sj: {
            title: "Acerca de nuestra Política de Privacidad:",
            subtitle: "Cómo respetamos tus datos",
            content: `
                <h5>¿Por qué recogemos tus datos?</h5>
                <p>Trabajamos para brindarle los mejores servicios y soporte, ¡ofreciendo siempre una experiencia buena y exclusiva! Por lo tanto, necesitamos recopilar algunos de sus datos.</p>
                <p>Utilizamos estos datos para que nuestra comunicación con usted sea lo más asertiva posible. De esta manera, es posible atenderle de forma personalizada.</p>
                <p>Además, necesitamos estos datos para cumplir con nuestras obligaciones legales y reglamentarias para que todo cumpla con la LGPD (Ley General de Protección de Datos).</p>
                <h5>¿Cómo utilizamos tus datos?</h5>
                <p>Podemos actuar de tres formas: como Responsable, Coresponsable o incluso como Operador de Datos Personales.</p>
                <p>Pero ¿qué significa esto? Consulta la descripción de cada clasificación: </p>
                <ol clase="px-5">
                <li><b>RESPONSABLE:</b> Utilizamos los datos para formalizar contratos con clientes, reclutamiento y selección, admisión, investigación, calificación de leads, acciones de marketing, investigación y actualización de información de leads;</li>
                <li><b>CO-CONTROLLADOR:</b> Los datos se utilizan para registrar a los empleados en planes de salud y dentales, nóminas y otros;</li>
                <li><b>OPERADOR:</b> Actividades relacionadas con la plataforma SELECTY, en particular el procesamiento, almacenamiento, acceso y eliminación de datos personales.</li>
                </ol>
                <h5>¿Con quién lo compartimos?</h5>
                <p>Internamente, los datos que recopilamos sólo son accedidos por profesionales autorizados, pensando siempre en la seguridad de tus datos y un mejor servicio para ti.</p>
                <p>Podemos compartir estos datos con nuestros socios, quienes siguen estándares de seguridad y confidencialidad. Siempre evaluamos a nuestros proveedores con mucho cuidado y contraemos obligaciones contractuales de seguridad de la información y protección de datos personales con ellos, con el objetivo de minimizar los riesgos.</p>
                <p>Algunas autoridades públicas (como autoridades reguladoras, ingresos federales, ministerios y otras autoridades nacionales) pueden tener acceso a los datos para cumplir con obligaciones legales o reglamentarias</p>
                <h5>¿Cómo protegemos tus datos?</h5>
                <p>Nuestras medidas para preservar los datos contra el acceso no autorizado, uso, alteración, divulgación o destrucción son:</p>
                <ul clase="px-5">
                <li>Protección física y digital contra intentos de acceso por parte de personas o programas desconocidos;</li>
                <li>Gestión de quién puede acceder a sus datos;</li>
                <li>Software y políticas de seguridad interna.</li>
                </ul>
                <p>Todos estos controles siempre son revisados ​​para monitorear el contexto de amenazas en Internet y contamos con equipos preparados para detectar y responder con prontitud en caso de un evento o incidente que comprometa la seguridad de sus datos o de nuestros servicios.</ p>p>
            `
        }
    },
    footer: {
        sj: {
            fastest_way_to_hire: "¡El camino más rápido para contratar y ser contratado! ;)",
            office_location: "Oficina Life Ecoville",
            office_address: "Profesor Pedro Viriato Parigot de Souza, 3901",
            welcome: "Estamos en Curitiba ♥ Cuna de la innovación",
            for_companies: "Para Empresas",
            post_your_jobs: "Publica tus ofertas",
            full_recruitment_management: "Gestión completa de R&S",
            outsource_your_job: "Externaliza tu vacante",
            for_candidates: "Para Candidatos",
            search_jobs: "Buscar Vacantes",
            create_profile: "Crear perfil",
            privacy_policy: "Política de Privacidad",
            faq: "Preguntas Frecuentes",
            follow_us: "¡Síguenos en las redes sociales!",
            copyright: "Copyright © {year} | Selecty.Jobs © Todos los derechos reservados",
            company: "Selecty Tecnologia para RH | CNPJ: 09.236.362/0001-50"
        },
        customer: {
            privacy_policy: "Política de Privacidad",
            cookie_policy: "Política de Cookies",
        },
    },
    domains: {
        logo_position: {
            normal: "Normal",
            centralized: "Centrado",
            top_square: "Cuadrado superior"
        },
        gender: {
            male_abb: "Masc",
            female_abb: "Fem",
            do_not_inform: "No informar",
        },
        nationalities: {
            brazilian_native: "Nativo brasileño",
            naturalized: "Naturalizado",
            foreigner: "Extranjero"
        },
        data_holder: {
            I_am_data_holder: "Soy el titular de los datos",
            I_am_attorney_or_representative: "Soy abogado o representante"
        },
        data_holder_category: {
            client: "Cliente",
            collaborator: "Colaborador",
            lead_prospect: "Lead/Prospecto",
            former_collaborator: "Ex-colaborador",
            supplier: "Proveedor"
        },
        exercise_rights: {
            correct_data_incomplete_inaccurate_outdated: "Corregir datos incompletos, inexactos o desactualizados",
            allow_data_portability: "Permitir la portabilidad de datos a otro proveedor de servicios o productos",
            receive_information_shared_entities: "Recibir información de entidades públicas y privadas con las que el controlador compartió datos",
            revoke_consent: "Revocar el consentimiento",
            review_automated_decisions: "Revisar decisiones tomadas únicamente sobre la base del procesamiento automatizado de datos personales",
            confirm_data_processing_and_access: "Solo confirmar la existencia de procesamiento y acceder a mis datos que están siendo tratados por Selecty"
        },
        result_request: {
            electronic_contact_email: "Medio electrónico (correo electrónico): el correo de contacto será el mismo proporcionado para el titular de los datos personales o abogado, cuando corresponda",
            printed_format_address: "Formato impreso: la dirección utilizada será la misma proporcionada para el titular de los datos personales o abogado, cuando corresponda"
        },
        armed_forces_service_status: {
            armed_forces_enlisted: "Alistado",
            armed_forces_reservist: "Reservista",
            armed_forces_exempt: "Exento"
        },
        bank_types: {
            bank_type_current_account: "Cuenta Corriente",
            bank_type_savings_account: "Cuenta de Ahorros",
            bank_type_salary_account: "Cuenta de Nómina"
        },
        bank_holder_types: {
            bank_holder_individual: "Persona Física",
            bank_holder_legal_entity: "Persona Jurídica"
        },
        bank_pix_types: {
            pix_type_not_informed: "No Informado",
            pix_type_phone: "Teléfono",
            pix_type_email: "Correo electrónico",
            pix_type_cpf_cnpj: "CPF/CNPJ",
            pix_type_random_key: "Clave Aleatoria"
        },
        tshirt: {
            tshirt_size_small: "S",
            tshirt_size_medium: "M",
            tshirt_size_large: "L",
            tshirt_size_extra_large: "XL",
            tshirt_size_extra_extra_large: "XXL"
        },
        benefits: {
            benefit_meal_voucher: "Vale de Comida",
            benefit_food_voucher: "Vale de Alimentación",
            benefit_medical_assistance: "Asistencia Médica <small>(verifique si su empresa es elegible para este beneficio)</small>",
            benefit_transport_voucher: "Vale de Transporte",
            benefit_no_voucher: "Sin beneficio",
        },
        way_transports: {
            go : "Ir",
            back : "Volver",
        },
        transports: {
            bus: "Autobús",
            subway: "Metro",
            train: "Tren",
            van: "Van",
            integration: "Integración",
        },
        vacancies: {
            vacancy_removed_from_favorites_success: "Puesto eliminado de tu lista de favoritos con éxito",
        },
        account: {
            registration_found: 'Localizamos su registro!',
            registration_found_provide_password: "Localizamos su registro, ¡por favor informe su contraseña!",
            user_not_registered_employee_portal_exclusive: "No encontramos su registro como colaborador. ¡Este portal es exclusivo para colaboradores!"
        },
        civil_status: {
            not_informed: "No informado",
            single: "Soltero",
            married: "Casado",
            separated: "Separado",
            divorced: "Divorciado",
            widowed: "Viudo",
            civil_union: "Unión Estable",
        },
        document_type: {
            national_registry_of_foreigners: "Registro Nacional de Extranjeros",
            passport: "Pasaporte",
            national_migration_registry: "Registro Nacional de Migración",
        },
        company_sizes: {
            large_company: "Empresa de gran tamaño",
            medium_company: "Empresa de tamaño medio",
            small_company: "Empresa de tamaño pequeño",
            micro_company: "Microempresa",
            self_employed_activity: "Actividad autónoma",
        },
        acting_areas: {
            agriculture_livestock: "Agricultura y Ganadería",
            food: "Alimentos",
            architecture: "Arquitectura",
            arts: "Artes",
            medical_assistance: "Asistencia Médica",
            associations: "Asociaciones",
            audit: "Auditoría",
            automotive: "Automotriz",
            auto_parts: "Autopartes",
            aviation: "Aviación",
            banks: "Bancos",
            beverages: "Bebidas",
            biological_sciences: "Ciencias Biológicas",
            gifts: "Regalos",
            toys: "Juguetes",
            footwear_leather: "Calzado y Cuero",
            bedding_bath: "Ropa de Cama y Baño",
            wholesale_trade: "Comercio Mayorista",
            foreign_trade: "Comercio Exterior",
            retail_trade: "Comercio Minorista",
            visual_communication_design: "Comunicación Visual y Diseño",
            civil_construction: "Construcción Civil",
            consulting: "Consultoría",
            accounting: "Contabilidad",
            brokerage: "Corretaje",
            dealership: "Concesionaria",
            distributors: "Distribuidores",
            education: "Educación",
            appliances: "Electrodomésticos",
            packaging: "Embalajes",
            energy: "Energía",
            engineering: "Ingeniería",
            teaching_research: "Enseñanza e Investigación",
            entertainment_culture_leisure: "Entretenimiento, Cultura y Ocio",
            sports: "Deportes",
            beauty_aesthetics: "Estética y Belleza",
            pharmaceutical: "Farmacéutico",
            tools: "Herramientas",
            finance: "Finanzas",
            franchises: "Franquicias",
            tobacco: "Tabaco",
            government: "Gobierno",
            printing: "Imprenta",
            hygiene_cleaning: "Higiene y Limpieza",
            hospitality: "Hostelería",
            real_estate: "Bienes Raíces",
            press_communication: "Prensa y Comunicación",
            industry: "Industria",
            internet: "Internet",
            legal: "Jurídico",
            wood: "Madera",
            machinery_equipment: "Maquinaria y Equipos",
            construction_material: "Material de Construcción",
            office_supplies: "Material de Oficina",
            electronic_material: "Material Electrónico (Componentes Electrónicos)",
            mechanics: "Mecánica",
            environment: "Medio Ambiente",
            metallurgy: "Metalurgia",
            mining: "Minería",
            furniture_decor: "Muebles y Decoración",
            non_metals: "No Metálicos",
            paper_pulp: "Papel y Celulosa",
            perfumery_cosmetics: "Perfumería y Cosméticos",
            petrochemical: "Petroquímica",
            plastic_rubber: "Plástico y Caucho",
            advertising: "Publicidad",
            chemistry: "Química",
            human_resources: "Recursos Humanos",
            religion: "Religión",
            health_hospital_lab: "Salud, Hospitalario y Laboratorio",
            insurance_private_pension: "Seguros y Pensiones Privadas",
            private_security: "Seguridad Privada",
            other_services: "Otros Servicios",
            public_services: "Servicios Públicos",
            technology_it: "Tecnología e Informática",
            telecommunications: "Telecomunicaciones",
            telemarketing: "Telemarketing / Centro de Llamadas",
            third_sector_ngo: "Tercer Sector / ONG",
            textile: "Textil",
            domestic_work: "Trabajo Doméstico",
            air_transport: "Transporte Aéreo",
            transport_logistics: "Transporte y Logística",
            tourism: "Turismo",
            housewares: "Utensilios Domésticos",
            clothing: "Ropa",
            veterinary: "Veterinaria",
        },
        admissional_education_level: {
            illiterate: "Analfabeto",
            up_to_5th_grade_elementary: "Hasta el 5º Año de Educación Primaria",
            completed_5th_grade_elementary: "5º año completo de Educación Primaria",
            from_6th_to_9th_grade_elementary: "Del 6º al 9º Año de Educación Primaria",
            completed_elementary: "Educación Primaria Completa",
            incomplete_high_school: "Escuela Secundaria incompleta",
            completed_high_school: "Escuela Secundaria completa",
            incomplete_higher_education: "Educación superior incompleta",
            completed_higher_education: "Educación superior completa",
            incomplete_postgraduate: "Posgrado incompleto",
            completed_postgraduate: "Posgrado completo",
            incomplete_master: "Maestría incompleta",
            completed_master: "Maestría completa",
            incomplete_doctorate: "Doctorado incompleto",
            completed_doctorate: "Doctorado completo",
            incomplete_postdoctorate: "Posdoctorado incompleto"
        },
        cnh_type: {
            a: "A",
            b: "B",
            c: "C",
            d: "D",
            e: "E",
            ab: "AB",
            ac: "AC",
            ad: "AD",
            ae: "AE",
            no_license: "No tengo licencia de conducir"
        },
        street_type: {
            airport: "Aeropuerto",
            alley: "Alameda",
            area: "Área",
            avenue: "Avenida",
            field: "Campo",
            farm: "Chacra",
            colony: "Colonia",
            condominium: "Condominio",
            complex: "Conjunto",
            district: "Distrito",
            esplanade: "Explanada",
            station: "Estación",
            road: "Carretera",
            shantytown: "Barrio bajo",
            market: "Mercado",
            garden: "Jardín",
            hill: "Ladera",
            lake: "Lago",
            lagoon: "Laguna",
            square: "Plaza",
            allotment: "Loteo",
            hillock: "Cerro",
            core: "Núcleo",
            park: "Parque",
            catwalk: "Pasarela",
            courtyard: "Patio",
            plaza: "Plaza",
            block: "Manzana",
            retreat: "Retiro",
            residential: "Residencial",
            highway: "Autopista",
            street: "Calle",
            sector: "Sector",
            ranch: "Rancho",
            lane: "Callejón",
            section: "Tramo",
            cloverleaf: "Distribuidor",
            valley: "Valle",
            path: "Vereda",
            way: "Vía",
            viaduct: "Viaducto",
            alleyway: "Callejuela",
            village: "Villa"
        },
        race: {
            no_information: "Prefiero no informar",
            white: "Blanca",
            black: "Negra",
            brown: "Mestiza",
            yellow: "Asiática",
            indigenous: "Indígena"
        },
        gender_identity: {
            cis_woman: "Mujer Cis",
            trans_woman: "Mujer Trans",
            cis_man: "Hombre Cis",
            trans_man: "Hombre Trans",
            non_binary: "No binario",
            other: "Otro",
            prefer_not_to_answer: "Prefiero no responder"
        },
        gender_orientation: {
            asexual: "Asexual",
            bisexual: "Bisexual",
            heterosexual: "Heterosexual",
            homosexual: "Homosexual",
            pansexual: "Pansexual",
            other: "Otro",
            prefer_not_to_answer: "Prefiero no responder"
        }
    },
};
